import { Select } from "ant-design-vue";
import { ASTOCK_LIST } from "../astock";

export default {
  root: {
    title: "TradingX: 算法交易和流动性提供商",
  },
  header: {
    menu: {
      tradingx: "TradingX",
      service: {
        title: "服务",
        subItems: {
          marketmaker: "做市商",
          digitalAssetManagement: "资产管理",
          advisory: "顾问服务",
        },
      },
      about: {
        title: "关于",
        subItems: {
          aboutUs: "关于我们",
          aboutCareer: "职业机会",
        },
      },
      contactUs: "联系我们",
    },
  },
  home: {
    menuItem: {
      production: "TradingX",
      service: "服务",
      about: "关于",
      contact: "联系我们",
    },
    intro: {
      whoWeArePart1: "我们是",
      whoWeArePart2: "全球领先的",
      whoWeArePart3: "算法交易",
      whoWeArePart4: "",
      whoWeArePart5: "公司",
      whatWeDo:
        "我们通过技术和交易，解决市场流动性和效率的问题，帮助成熟的投资者实现财务成果并推动经济的发展。",
      tradingVolumn: "交易量",
      scientificBasis: "科学依据",
      client: "客户",
    },
    services: {
      title: "科技与金融的碰撞",
      content: "构筑智能的、动态的交易系统，推动资本的高效配置和金融创新。",
      aiResearch: {
        title: "AI研究",
        subtitle: "释放AI的潜力",
        content:
          "我们深度探索AI，创造卓越算法与训练模型，利用AI的强大驱动寻找市场机会和规避风险，拓展金融边界，为算法交易带来更高的效益和成功。",
      },
      marketmaker: {
        title: "做市商",
        subtitle: "市场不可或缺的角色",
        content:
          "作为做市商，我们融合数学、金融学和计算机等专业学科，通过深厚的底蕴和卓越的交易能力为市场提供流动性，增强市场的可访问性，维持市场的稳定和效率。",
      },
      crypto: {
        title: "跨市场组合投资",
        subtitle: "财富增长的新范式",
        content:
          "我们擅长量化对冲交易，并保持技术创新和金融革命。我们的投资组合横跨美股、加密资产及RWA，实现多维度风险分散与收益捕获。",
      },
    },
    cooperatorCarousel: {
      title: "我们与全球领先的企业合作",
    },
    exploration: {
      text: "从这里开始，了解算法交易的魅力",
    },
  },
  product: {
    header: {
      title: "资产管理的最佳拍档",
      content:
        "顶级的交易仪表盘，先进的策略、高质量的执行和深度的流动性聚合，为专业交易者提供白手套服务，在任何周期都能轻松交易。",
    },
    products: {
      trade: {
        title: "交易",
        content: {
          aggregateTransaction: {
            subtitle: "聚合交易",
            desc1:
              "链接主流交易平台，聚合市场深度，实现同一平台执行复杂的交易计划。",
            desc2: "",
          },
          engine: {
            subtitle: "高效执行引擎",
            desc1: "极速执行，保持低延迟和高吞吐量，确保交易的即时性和精确性。",
            desc2: "",
          },
          tradingview: {
            subtitle: "集成 TradingView 高级组件",
            desc1:
              "一个高级、专业的金融数据可视化工具，支持多市场分析与多指标叠加，助力交易决策。例如，通过",
            desc2: "的价格趋势图体验专业的市场数据可视化。",
          },
        },
      },
      aiTrade: {
        title: "AI交易",
        content: {
          algorithmFrame: {
            subtitle: "领先的算法框架",
            desc: "融合金融工程、数学和AI等领域的研究，部署了领先的算法交易框架。",
          },
          riskSmartManagement: {
            subtitle: "智能风险管理",
            desc: "对潜在的市场风险进行量化分析，实时调整策略，保障交易安全。",
          },
          strategyOptimization: {
            subtitle: "自适应策略优化",
            desc: "AI系统根据实时市场快速识别机会与学习，自适应优化策略，确保持续的投资回报。",
          },
          solvingStrategy: {
            subtitle: "高级量化策略",
            desc: "AI技术为量化策略提供决策支持。做市策略借助AI，提供流动性，最大化收益并有效管理风险。",
          },
        },
      },
      accountManagement: {
        title: "统一账户管理",
        content: {
          assetManagement: {
            key: "account-1",
            subtitle: "一站式资金管理",
            desc: "跨平台的资产统一管理和结算，简化资金管理流程。",
          },
          maximizeEfficiency: {
            subtitle: "资金效率最大化",
            desc: "更高效地调度资金，实现资金的最优配置和利用。",
          },
        },
      },
      dataAnalysis: {
        title: "数据分析",
        content: {
          marketInsight: {
            subtitle: "深度市场洞察",
            desc: "深度数据挖掘和分析，形成市场洞察报告，辅助决策。",
          },
          transactionDataAnalysis: {
            subtitle: "交易数据分析",
            desc: "投资报告和反馈，包括投资回报率分析和执行质量评估，全面监控财务状况和投资组合表现。",
          },
        },
      },
    },
    startup: {
      header: {
        title: "为专业投资人设计的算法交易平台",
        content:
          "我们召集了各个学科最聪明的人，创造了探索金融科技的一切条件，共同实现我们的野心。",
      },
      list: {
        quantitativeTrading: "AI量化交易",
        deepLiquidity: "深度的流动性",
        customizableStrategy: "可定制的策略",
        investmentAnalysis: "数据与投资分析",
      },
      button: {
        text: "想突破投资边界吗？从这里开始",
      },
    },
  },
  marketMaker: {
    banner: {
      title: {
        part1: "做市商",
        part2: "为市场注入关键流动性",
      },
      content: "流动性是衡量资产是否快速交易且不引起价格波动的关键指标。",
    },
    intro: {
      title: "关于做市商",
      content:
        "做市商类似于“市场的中枢神经”，它们通过快速响应市场信号，协调买卖双方的交易需求，确保信息的即时传递和交易的顺畅执行，为市场创造流动性。做市商通过稳定价格和提供即时交易机会，对市场的稳定和效率至关重要。",
    },
    style: {
      title: "TradingX 的做市风格",
      content:
        "作为加密市场的做市商，TradingX降低资本配置与市场创新的成本，为市场注入关键流动性，给予全球交易者、投资机构和市场参与者无缝的交易体验。",
      styles: {
        flow: {
          subtitle: "流动性",
          content: "与全球领先的交易所深度合作，为其提供更强劲的流动性。",
        },
        dataAnalysis: {
          subtitle: "数据分析",
          content: "强大可靠的数据库及时智能生成报告，决策更快更准。",
        },
        algorithmTrade: {
          subtitle: "做市算法",
          content:
            "做市算法结合最新的AI技术，为市场提供一种高效、精确的流动性解决方案。",
        },
        experience: {
          subtitle: "经验",
          content: "熟悉项目和交易所的交易生态需求，提供定制化服务。",
        },
      },
    },
    tip: "流动性对交易所来说极其重要。通常流动性低的订单簿价差和波动性都比较大，买家和卖家很难以合适的价格成交，只有确保资产的流动性，买卖双方才能随时快速交易。",
    contact: {
      title: "如果您需要",
      lyrics: {
        enhanceLiquidity: {
          title: "增强流动性",
          content: "减少买卖价差，提升交易效率。",
        },
        stabilizePrice: {
          title: "稳定价格",
          content: "缓解价格波动，维持交易生态的稳定性。",
        },
        manageCostsNRisks: {
          title: "管理成本与风险",
          content: "更精确的交易进出点，减少交易滑点。",
        },
        institutionalLevelServices: {
          title: "机构级服务",
          content: "支持大型的交易需求。",
        },
        solution: {
          title: "解决方案",
          content: "解决方案：流动性策略，加密投资等咨询。",
        },
      },
    },
    joinUs: {
      content: "需要一个靠谱的合作伙伴？我们的团队随时为您提供帮助！",
      button: {
        text: "联系我们",
      },
    },
  },
  digitalAssetManagement: {
    banner: {
      title: "资产管理",
      content: "AI算法交易体系的领先性和强劲的流动性带来持续稳定的投资回报",
    },
    management: {
      title: "资产管理",
      content: {
        part1: "利用我们经过验证的算法，无论在任何市场环境都能获得投资回报。",
        part2:
          "我们的服务与支持，让更多投资者有效地参与股票、数字资产和RWA等投资。",
      },
      AMIs: {
        am1: {
          subtitle: "流动性与市场接入",
          content:
            "广泛的市场接入和高效的流动性管理，确保客户资产在全球范围内实现最优配置。",
        },
        am2: {
          subtitle: "AI增强的策略",
          content:
            "我们通过AI增强策略能力，持续优化交易模型，实现超前的洞察和交易。",
        },
        am3: {
          subtitle: "稳健的投资表现",
          content:
            "凭借先进的量化交易策略和执行，不管在任何市场环境都可获得投资回报。",
        },
        am4: {
          subtitle: "风险管理与合规",
          content:
            "我们的全面风险管理框架结合合规性标准，确保投资的透明性和资产的安全性。",
        },
        am5: {
          subtitle: "第三方托管",
          content: "我们支持第三方托管服务，减少交易对手的风险。",
        },
        am6: {
          subtitle: "定制化投资方案",
          content:
            "我们结合客户的个人目标和风险偏好提供定制化的投资方案，实现个性化的资产管理。",
        },
      },
    },
    tip: "市场以其剧烈的价格波动、复杂的技术和不断变化的监管环境而闻名，这些因素共同构成了一个高度动荡和复杂的投资领域。在这样的背景下，投资者面临着识别和评估真正投资机会的挑战。",
    issue: {
      title: "投资者面临的问题",
      content: {
        c1: "受限于准入壁垒与账户基础设施，难以跨市场配置多元资产类别。",
        c2: "市场深度不透明，很难辨别市场数据和报告的真实性，导致投资失误",
        c3: "执行质量低，难以处理大型交易，容易导致高滑点等风险",
        c4: "面对市场波动时常受情绪驱动，作出非理性决策",
      },
    },
    sciManagement: {
      title: "科学的资产管理",
      content:
        "我们运用科学的方法解析资产市场，基于精确的交易模型进行战略性投资，即使在熊市也获得稳定的投资回报。",
      SMs: {
        sm1: {
          subtitle: "算法执行",
          content: "自动遵循交易规则，高质量执行，减少人为失误。",
        },
        sm2: {
          subtitle: "交易系统",
          content:
            "我们的系统确保了低延遲、高吞吐量的全球交易，保障卓越交易性能。",
        },
        sm3: {
          subtitle: "数据网络",
          content: "辨别复杂的市场，是投资决策的可靠依据。",
        },
        sm4: {
          subtitle: "多元化策略",
          content:
            "因子研发是我们的专长，结合AI形成可预测，可自主优化的多元化策略。",
        },
        sm5: {
          subtitle: "风险管理",
          content: "完善的风控系统即时监控策略表现，确保投资计划稳定进行。",
        },
        sm6: {
          subtitle: "白手套服务",
          content: "24x7机构级白手套服务，为客户提供安心的资产投资体验。",
        },
      },
    },
    contact: {
      text: "如果您需要一个值得信赖的合作伙伴，请联系我们。",
      button: {
        text: "联系我们",
      },
    },
  },
  advisory: {
    banner: {
      title: "顾问服务",
      content1: "我们为棘手的问题找到优雅的解决方案",
      content2:
        "TradingX提供深入且全面的顾问服务，凭借丰富的专业知识，行业洞见和先进的技术，我们有效地把握市场动态，从客户利益出发，持续为客户创造价值。我们顾问服务的对象主要是金融机构，项目和高净值人群。",
    },
    advisory: {
      AIs: {
        FI: {
          subtitle: "金融机构",
          subContent:
            "我们了解金融机构在加密行业探索中的问题：即市场的复杂性、未来的不确定性以及跨学科知识的挑战。我们具备深厚的传统金融经验和多学科的视野与创新力，为金融机构量身定制个性化的解决策略，帮助金融机构在变幻莫测的加密市场中精准识别风险、捕捉机遇，实现资产的稳健增长与长期的成功。",
          subItems: {
            fi1: {
              name: "进入加密市场",
            },
            fi2: {
              name: "投资战略建议",
            },
            fi3: {
              name: "算法交易",
            },
            fi4: {
              name: "金融科技研究",
            },
            fi5: {
              name: "风险管理",
            },
            fi6: {
              name: "流动性管理",
            },
          },
        },
        project: {
          subtitle: "项目",
          subContent:
            "我们为项目方提供全面的咨询和定制方案，以应对代币发行和市场生命周期管理中的挑战。通过我们的深度流动性和技术，实现更高的市场占用率和风险管理。我们与有野心的，计划在一流交易所上市的项目合作。",
          subItems: {
            p1: {
              name: "流动性管理",
            },
            p4: {
              name: "生态系统建设",
            },
            p5: {
              name: "风险管理",
            },
          },
        },
        HNWI: {
          subtitle: "高净值人群",
          subContent:
            "多市场组合投资虽然充满潜力，但也伴随着一系列疑虑和挑战。市场的不透明性、技术的复杂性以及资产管理的专业性，往往让个人投资者感到困惑和不安。我们擅长解决这些困惑，降低加密投资门槛，减少投资者的参与摩擦。",
          subItems: {
            hnwi1: {
              name: "市场洞察与分析",
            },
            hnwi2: {
              name: "定制化资产管理",
            },
            hnwi3: {
              name: "算法交易",
            },
            hnwi4: {
              name: "金融科技研究",
            },
            hnwi5: {
              name: "风险管理",
            },
            hnwi6: {
              name: "24/7专属客服",
            },
          },
        },
      },
    },
    contact: {
      left: {
        h1: "让TradingX成为推动您资产战略发展的加速器。",
        button: "联系我们",
      },
      right: {
        h1: "关联服务",
        list: {
          l1: "TradingX",
          l2: "做市商",
          l3: "资产管理",
        },
      },
    },
  },
  aboutUs: {
    banner: {
      left: {
        title: "了解TradingX",
        content1:
          "TradingX是一家领先的算法交易公司，我们通过算法增强市场的无缝运作和可访问性，拓展金融的边界。作为全球流动性提供者，我们持续为市场注入活力，推动市场的效率，透明度和创新。",
        content2:
          "我们的成员专注于技术研发和金融创新，是充满活力的问题解决者，我们相信金融科技的未来，并保持耐心与创造。",
      },
      right: {
        stats: {
          stat1: {
            name: "交易量",
          },
          stat2: {
            name: "科学依据",
          },
          stat3: {
            name: "客户",
          },
          stat4: {
            name: "客户服务",
          },
        },
      },
    },
    duty: {
      title: "我们的使命",
      content1: "TradingX是全球领先的算法交易公司，",
      content2:
        "我们的使命不断拓展金融边界，赋能市场参与者，促进市场的透明度、公平性和效率。",
    },
    values: {
      header: {
        title: "我们的价值观",
        content:
          "我们的价值观汇聚了全球志同道合的人才，紧密协作创造领先的算法交易生态，共同促进金融科技的繁荣。",
      },
      valuesItems: {
        v1: {
          title: "诚信",
          content: "我们以最高的道德和法律标准为行为准则，保持真诚和负责任。",
        },
        v2: {
          title: "精确",
          content:
            "坚持精确，细致入微的态度，追求在研究、决策和执行过程中的高标准和高质量。",
        },
        v3: {
          title: "开放",
          content:
            "我们拥有开放的工作环境，倡导多元思维的碰撞与跨学科交流，组建卓越团队。",
        },
        v4: {
          title: "创新",
          content:
            "我们敢于突破边界，探索未知，通过创新不断自我超越，推动行业进步。",
        },
        v5: {
          title: "获胜",
          content:
            "我们不断精进，提升胜率，在市场博弈中战胜对手。不断探索新战略，帮客户战胜难题。",
        },
        v6: {
          title: "互惠",
          content:
            "我们与客户、合作伙伴及成员建立互惠共赢的长期合作，共同分享成长与成功。",
        },
      },
    },
    ourTeam: {
      header: {
        title: "我们的综合团队",
        content:
          "我们的团队由金融工程、数学科学、工程等领域的顶级人才构成，推动金融科技革新和实现共同的使命。",
      },
      ourTeamItems: {
        ot1: {
          title: "AI科研",
          content:
            "我们的专家团队致力于AI技术的研究，以实现交易算法的自我优化和市场适应性的提升。",
        },
        ot2: {
          title: "工程",
          content:
            "我们的工程团队专注于构建可扩展、高可靠性的基础设施，确保系统的高可用性和低延迟，满足大规模交易的需求。",
        },
        ot3: {
          title: "市场与交易",
          content:
            "市场与交易团队凭借对市场的深刻洞察，执行精确的交易操作，同时管理和对冲市场风险，以实现稳健的交易表现。",
        },
        ot4: {
          title: "量化研究",
          content:
            "量化研究团队擅长数学模型和统计，在动荡市场中的发现细微的联系，构建驱动交易的复杂算法。",
        },
        ot5: {
          title: "商业咨询",
          content:
            "我们的商业咨询团队提供定制化解决方案，帮助客户理解市场和制定策略，以实现商业目标。",
        },
      },
    },
    solve: {
      header: {
        title: "我们解决了什么",
        content: "通过我们的专业，解决复杂的市场问题",
      },
      solveArounds: {
        sa1: {
          name: "研发与部署",
        },
        sa2: {
          name: "风险管理",
        },
        sa3: {
          name: "投研与分析",
        },
        sa4: {
          name: "数字资产管理",
        },
        sa6: {
          name: "流动性管理",
        },
        sa8: {
          name: "定制化服务",
        },
      },
    },
  },
  aboutCareer: {
    banner: {
      h1: "职业机会",
      h2: "创造迭代人生策略，实现自己的野心。",
      p1: {
        part1: "我们汇聚来自不同背景的人才，共同打造一个自由的、多元化的团队。",
        part2: "在探索未知和挑战对手无法解决的难题的过程中，实现我们的抱负。",
      },
      p2: "我们野心勃勃并且对算法交易充满热情，如果您也一样，请申请！",
    },
    job: {
      header: {
        title: "开放职位",
      },
      jobs: {
        quantitativeResearcher: {
          name: "量化研究员",
        },
        engineer: {
          name: "资深工程师",
        },
        trader: {
          name: "交易员",
        },
        applyButton: {
          text: "申请",
        },
      },
    },
    careers: {
      quantitativeResearcher: {
        name: "量化研究员",
        remote: {
          location: "香港",
          mode: "全职",
        },
        applyButton: {
          text: "申请职位",
        },
        finding: {
          f1: "我们寻找的是热爱数学并擅长编写自动交易算法的人。您应在创造和回测上有天赋，擅长生成Alpha和自动化策略。您将与交易员和开发人员密切合作，提出假设、收集数据并进行分析以开发新算法。",
          f2: "TradingX正在寻找资深量化研究员，这是一个加入全球领先算法交易公司难得的机会，我们重视不同背景的，有创造力的人才，并鼓励他们充分发挥自己的潜力。在TradingX，您将有机会与各个领域的天才们一起解决有意义的问题，并成为前沿领域的专家。我们努力照顾我们的员工，提供有竞争力的激励、福利和奖励。",
        },
        candidate: {
          title: "我们的理想候选人：",
          needs: {
            n1: {
              content: "2年以上量化研究经验，特别是在做市商定价和对冲策略方面",
            },
            n2: {
              content:
                "拥有计量经济学、数学、物理学、统计学、计算机科学或相关学科的硕士以上学位",
            },
            n3: {
              content:
                "对数字资产的市场微观结构有深刻的理解，精通至少一种编程语言，如Java，Python或C++",
            },
            n4: {
              content: "具备低延迟交易系统的经验、强大的数学和统计能力",
            },
            n5: {
              content: "出色的逻辑思维和问题解决能力，能在压力下工作并承担责任",
            },
            n6: {
              content:
                "敢于竞争，持续学习，积极主动，擅于协作，优秀的沟通技巧，英语能力强优先",
            },
          },
        },
        todos: {
          title: "您需要做的是：",
          td1: {
            content: "与交易员和工程团队合作，优化和创新交易策略",
          },
          td2: {
            content: "对数据进行深入研究和分析，识别和利用市场模式",
          },
          td3: {
            content: "设计和实现复杂的量化模型和自动化交易算法",
          },
        },
      },
      engineer: {
        name: "资深工程师",
        remote: {
          location: "香港",
          mode: "全职",
        },
        applyButton: {
          text: "申请职位",
        },
        finding: {
          f1: "我们的工程师与研究员和交易员合作，解决大规模复杂问题。我们的团队能够快速将想法付诸实施，市场也能迅速提供反馈。",
          f2: "TradingX正在寻找资深工程师，这是一个加入全球领先算法交易公司难得的机会，我们重视不同背景的，有创造力的人才，并鼓励他们充分发挥自己的潜力。在TradingX，您将有机会与各个领域的天才们一起解决有意义的问题，并成为前沿领域的专家。我们努力照顾我们的员工，提供有竞争力的激励、福利和奖励。",
        },
        candidate: {
          title: "我们的理想候选人：",
          needs: {
            n1: {
              content:
                "计算机科学、工程学、统计学、数学、物理学或相关领域的硕士学位",
            },
            n2: {
              content: "卓越的设计和编程技能，具备多种编程语言的能力",
            },
            n3: {
              content: "能够在复杂且技术含量高的团队环境中协助和有效沟通",
            },
            n4: {
              content: "对利用技术解决挑战性问题的好奇心和热情",
            },
            n5: {
              content: "具备较强的分析能力，熟悉概率和统计学",
            },
            n6: {
              content: "曾在金融科技公司工作，能进行区块链开发",
            },
          },
        },
        todos: {
          title: "您需要做的是：",
          td1: {
            content: "设计和开发金融市场产品，包括低延迟算法交易平台",
          },
          td2: {
            content: "实施、验证并执行软件测试",
          },
          td3: {
            content: "支持研究员和交易员，确保算法的实施",
          },
          td4: {
            content: "创建并维护文档，编写功能和设计规范",
          },
          td5: {
            content: "根据需求改进和定制系统",
          },
          td6: {
            content: "编码开发和调试，包括相关的自动化单元和集成测试",
          },
        },
      },
      trader: {
        name: "交易员",
        remote: {
          location: "香港",
          mode: "全职",
        },
        applyButton: {
          text: "申请职位",
        },
        finding: {
          f1: "我们的交易员与研究员和工程师合作，共同将伟大的想法付诸实践，取得更好的结果。",
          f2: "TradingX正在寻找交易员，这是一个加入全球领先算法交易公司难得的机会，我们重视不同背景的，有创造力的人才，并鼓励他们充分发挥自己的潜力。在TradingX，您将有机会与各个领域的天才们一起解决有意义的问题，并成为前沿领域的专家。我们努力照顾我们的员工，提供有竞争力的激励、福利和奖励。",
        },
        candidate: {
          title: "我们的理想候选人：",
          needs: {
            n1: {
              content: "金融、经济学、数学、统计学或相关领域的硕士学位",
            },
            n2: {
              content: "至少2年加密行业交易经验",
            },
            n3: {
              content: "对金融市场和交易策略有广泛的了解，尤其是做市",
            },
            n4: {
              content: "强大的分析、定量和人际交往能力",
            },
            n5: {
              content: "具备评估新代币相关的风险和机会的能力",
            },
            n6: {
              content:
                "能够管理复杂的交易和头寸，并随时了解加密市场趋势和监管变化",
            },
            n7: {
              content: "敢于竞争，持续学习，积极主动，擅于协作",
            },
            n8: {
              content: "优秀的沟通技巧，英语能力强优先",
            },
          },
        },
        todos: {
          title: "您需要做的是：",
          td1: {
            content: "具备丰富的数字资产交易知识以及在全球交易所进行交易的经验",
          },
          td2: {
            content: "与ICO发行人合作，促进一级市场交易并确保及时高效执行",
          },
          td3: {
            content: "确定潜在的做市机会和策略优化",
          },
          td4: {
            content: "洞察市场，制定计划，识别风险并大规模执行复杂交易",
          },
          td5: {
            content: "提高我们数字资产业务的整体盈利能力",
          },
        },
      },
      application: {
        title: "填写申请表",
        applyForm: {
          candidateInfo: {
            h1: "候选人信息",
            name: {
              label: "名称",
              placeholder: "请问如何称呼您",
            },
            resume: {
              label: "简历/履历",
              placeholder: "上传您的简历或履历 (.pdf, .doc)",
            },
            phone: {
              label: "电话",
              placeholder: "您的手机号",
            },
            email: {
              label: "邮箱",
              placeholder: "您的邮箱地址",
            },
            currentCompany: {
              label: "现就职公司",
              placeholder: "您的公司名称",
            },
          },
          candidateLinks: {
            h1: "链接",
            linkedIn: {
              label: "LinkedIn网址",
              placeholder: "您的领英网址",
            },
            github: {
              label: "Github网址",
              placeholder: "您的Github网址",
            },
            combine: {
              label: "组合网址",
              placeholder: "您的组合网址",
            },
            other: {
              label: "其他网址",
              placeholder: "您的其他网址",
            },
          },
          candidateExtra: {
            h1: "附加信息",
            p: "添加求职信或任何其他您想要分享的内容",
          },
          submitButton: {
            text: "提交申请表",
          },
          notification: {
            submit: {
              success: {
                message: "提交成功",
                description: "您的申请表已经成功提交！",
              },
              error: {
                message: "提交失败",
                description: "申请表提交失败，请联系管理员。",
              },
            },
          },
          Rules: {
            ResumeRule: {
              IsNotNull: "简历/履历不能为空",
              IsOversize: `简历文件过大，上限10M`,
            },
          },
        },
      },
    },
  },
  contactUs: {
    banner: {
      text: "联系TradingX",
    },
    contact: {
      h1: "请完成表单和我们联系",
      formItems: {
        firstName: {
          placeholder: "名*",
        },
        lastName: {
          placeholder: "姓*",
        },
        email: {
          placeholder: "电子邮件*",
        },
        telegram: {
          placeholder: "电报*",
        },
        company: {
          placeholder: "公司*",
        },
        position: {
          placeholder: "职位",
        },
        interest: {
          placeholder: "我感兴趣的是*",
          options: {
            opt1: {
              name: "TradingX",
            },
            opt2: {
              name: "资产管理",
            },
            opt3: {
              name: "做市商",
            },
            opt4: {
              name: "合作伙伴关系",
            },
          },
        },
        business: {
          placeholder: "业务*",
          options: {
            opt1: {
              name: "对冲基金",
            },
            opt2: {
              name: "风险投资基金",
            },
            opt3: {
              name: "机构财富管理人",
            },
            opt4: {
              name: "金融中介",
            },
            opt5: {
              name: "自营交易者",
            },
            opt6: {
              name: "金融基础设施提供商",
            },
            opt7: {
              name: "高净值个人",
            },
            opt8: {
              name: "其他",
            },
          },
        },
        assetRange: {
          placeholder: "管理资产规模范围*",
          options: {
            opt1: {
              name: "<1M",
            },
            opt2: {
              name: "1M-10M",
            },
            opt3: {
              name: "10M-100M",
            },
            opt4: {
              name: "100M-500M",
            },
            opt5: {
              name: "500M-1B",
            },
            opt6: {
              name: ">1B",
            },
          },
        },
        country: {
          placeholder: "国家*",
        },
        submitButton: {
          text: "提交",
        },
      },
    },
  },
  footer: {
    media: {
      title: "社交媒体",
    },
    production: {
      title: "产品",
      tradingx: "TradingX",
    },
    about: {
      title: "关于",
      aboutUs: "关于我们",
      career: "职业机会",
    },
    service: {
      title: "服务",
      marketMaker: "做市商",
      digitalAssetManagement: "资产管理",
      consultationService: "顾问服务",
      serviceObject: "",
    },
    contact: {
      title: "联系我们",
      contact: "联系",
    },
  },

  sider: {
    trade: "交易",
    account: "账户",
    AITrade: "AI交易",
    TradeData: "交易数据",
    data: "数据",
    Settings: "设置",
  },
  KChat: {},
  dashboardTrade: {
    PleaseSelectPosition: "请选择仓位",
    AllClosePosition: "所选一键平仓",
    SyncMode: "同步下单",
    Cont: "张",
    Lot: "手",
    IsHideMin: "隐藏小额资产",
    IsShowZero: "显示0资产",
    Asset: "资产",
    Query: "查询",
    OpenLong: "开多",
    CloseShort: "平空",
    open: "开仓",
    close: "平仓",
    Spot: "现货",
    Index: "指数",
    Futures: "期货",
    Forex: "外汇",
    AStock: "A股",
    AStock_SH: "上证",
    AStock_SZ: "深证",
    CloseLong: "平多",
    OpenShort: "开空",
    USDFutures: "U本位合约",
    COINFutures: "币本位合约",
    Perpetual: "永续",
    Quarterly: "次季",
    Currently: "当季",
    DayChange: "涨跌",
    DayHigh: "最高价",
    DayLow: "最低价",
    DayVolumeone: "成交量",
    DayVolumetwo: "成交额",
    Day: "日",
    Shares: "股",

    DayOpenPrice: "今开",
    DayPreClosePrice: "昨收",
    DayUpperLimit: "涨停",
    DayLowerLimit: "跌停",

    Price: "价格",
    Amount: "数量",
    Total: "总额",
    Buy: "买入",
    Sell: "卖出",
    Limit: "限价",
    MaxBuy: "可开",
    Available: "可用",
    Balance: "余额",
    AcceptQuotesSpread: "允许价差",
    QuickMode: "快速模式",
    Market: "市价",
    LogIn: "前往登录",
    TriggerOrder: "止盈止损",
    TriggerPrice: "触发价",
    Tradeatthebestprice: "以市场最优价成交",
    ActivateAccount: "请先激活账户",
    SwitchMainAccount: "请先切换主账户",
    Markets: "行情",
    Depth: "深度",
    OpenOrders: "当前委托",
    SubAccount: "子账户",
    Pair: "交易对",
    Time1: "日期",
    Side: "方向",
    Amount1: "委托量",
    Total1: "委托额",
    FilledAmount: "成交量",
    TotalFilled: "成交额",
    AveragePrice: "成交均价",
    ExecutionTime: "执行时间",
    Status: "执行状态",
    OrderStatus: "订单状态",
    TimeInForce: "订单有效方式",
    ImpactPercent: "冲击量",
    EnableImpactPercent: "启用冲击量",
    EnableMarginAccount: "启用杠杆账户",
    EnableSpotAccount: "启用现货账户",
    OrderType: "订单类型",
    OrderQty: "数量",
    PositionSide: "持仓方向",
    TradeRate: "成交率",
    Action: "操作",
    CancelAllOrder: "一键撤单",

    MarginSmallLiability: "小额负债转换",
    MarginSmallBnb: "小额兑换BNB",
    PortfolioMarginRepay: "归还指定币种负债",
    PortfolioContractAutoRepay: "自动清还合约负余额",
    PortfolioAutoCollect: "资金归集",

    ConfirmMarginSmallLiability: "确认执行全仓杠杆账户小额负债转换？",
    ConfirmMarginSmallBnb: "确认执行全仓杠杆账户小额兑换BNB？",
    ConfirmPortfolioMarginRepay: "确认执行统一账户归还指定币种负债？",
    ConfirmPortfolioContractAutoRepay: "确认执行统一账户自动清还合约负余额？",
    ConfirmPortfolioAutoCollect: "确认执行统一账户资金归集？",

    OrderHistory: "历史委托",
    PositionHistory: "历史平仓",
    AveragePositionCost: "仓位成本均价",
    AverageClosePrice: "平仓均价",
    CloseAmount: "平仓数量",
    RealizedPnL: "已实现盈亏(USD)",
    Position: "仓位",
    Typenew: "仓位类型",
    OpenPositions: "当前持仓",
    AverageOpenPrice: "开仓均价",
    PositionValue: "仓位价值",
    MarkPrice: "标记价格",
    Margin: "保证金",
    MarginRatio: "保证金率",
    UnrealizedPnL: "未实现盈亏",
    ExchangePosition: "交易所仓位",
    ExchangeOpenOrder: "交易所挂单",
    OpenOrder: "当前挂单",
    LiqPrice: "强平价格",
    Time: "委托时间",
    Type: "委托类型",
    CurrentTokensOnly: "隐藏其他币种",
    TriggerOrderLimit: "条件委托限价",
    TriggerOrderMarket: "条件委托市价",
    BaseVersion: "尊享版",
    ProVersion: "专业版",
    Details: "详情",
    Revoke: "撤销",
    NineRounds: {
      Name: "九转局",
      NineRoundsA: {
        Name: "九转局A",
        TwoPointMethod: "两点法",
        ThreePointMethod: "三点法",
      },
      NineRoundsD: {
        D1Name: "九转局D1",
        D2Name: "九转局D2",
        SpaceMethod: "空间法",
        TimeMethod: "时间法",
      },
      Delete: "删除图",
      MessageText: {
        RenderError: "无法绘制九转局，请重新切换时间或重新绘制",
        Open: "开",
        High: "高",
        Low: "低",
        Close: "收",
        Volume: "成交量",
        FirstPoint: "第一点",
        SecondPoint: "第二点",
        ThirdPoint: "第三点",
        NewestPrice: "最新价格",
        RenderTipsClickTwo: "请点击两个点",
        RenderTipsClickThree: "请点击三个点",
        ConfirmRender: "是否确认绘制九转局?",
        ConfirmReRender: "是否重新绘制九转局?",
        WillClear: "将清除现有九转局",
        Time: "时间",
        Price: "价格",
      },
    },
    Layout: {
      Name: "布局",
      Lock: "移动布局",
      AutoSave: "自动保存",
      Rename: "重命名",
      NewLayout: "新建布局",
      MyLayout: "我的布局",
      RecoverDefault: "恢复默认",
      ConfirmDelete: "确认删除该布局?",
      ConfirmDeleteTip: "此操作不可恢复。",
      Cancel: "取消",
      Confirm: "确认",
      SubMap: "分图",
      BrowserNotSupport: "当前用户浏览器不支持Canvas,请更换浏览器重试！",
      SaveSuccess: "保存成功",
      SaveFail: "保存失败",
      DeleteSuccess: "删除成功",
      DeleteFail: "删除失败",
    },
    RuleMessageTest: {
      NumRule: {
        IsNotNum: "请输入数字",
        IsIllegalNum: "请输入合法数字",
        IsNotNull: "不能为空",
      },
      EmailRule: {
        IsIllegalEmail: "请输入正确的邮箱地址",
        IsNotNull: "邮箱地址不能为空",
      },
      PhoneRule: {
        IsNotNull: "手机号不能为空",
        IsIllegalPhoneNumber: "请输入正确的手机号",
      },
    },
    Deribit: {
      Position: "仓位",
      OpenOrder: "未结订单",
      OrderHistory: "订单历史记录",
      PositionHistory: "仓位历史记录",
    },
  },
  views_login: {
    login: "登录",
    login_input_userName_placeholder: "请输入邮箱/手机号",
    login_input_correct_email: "请输入正确的邮箱",
    login_input_password_placeholder: "请输入密码",
    login_input_VerificationCode_placeholder: "请输入验证码",
    login_remember_password: "记住密码",
    login_forget_password: "忘记密码？",
    reset: "重置",
    reset_password_success: "重置密码成功",
    reset_password: "重置密码",
    login_register: "立即注册",
  },
  client_things: {
    TotalVolume: "总成交量",
    WeekVolume: "周成交量",
    TotalMMVolume: "做市商成交总量",
    OrderQuantity: "订单成交笔数",
    CommisionSaving: "总节省手续费",
    TotalRebate: "返佣总额",
    TotalSaving: "总节省成本",
    TradeNow: "去交易",
    client_present: "让交易更简单",
    client_present_long: "数字资产投资管理平台",
    standard: "BTC现货已获得SEC标准",
    standardMore: "详情",
    WhyTradingX: "TradingX的优势",
    Executeinaggregation: "高效聚合执行",
    Leadingmarketmakingtools: "全周期策略",
    DataAnalysis: "数据分析",
    ComplianceSecurity: "合规风控",
    Executeinaggregationnew:
      "一个界面一键执行不同交易所的交易计划，减少和交易所打交道。",
    Leadingmarketmakingtoolsnew:
      "领先的做市工具全自动交易机器人和半自动工具，帮助投资人无论在什么市场都能赢得优势。",
    DataAnalysisnew:
      "主流数字资产链上数据、DEXs和CEXs的交易数据及全球股市、汇市、黄金等交易数据的分析，帮助优化投资组合",
    ComplianceSecuritynew: "新加坡和香港证券牌照，让交易更安心",
    Announcement: "平台公告",
    UserGuide: "使用教程",
    ContactJoinUs: "联系/加盟我们",
  },
  components_myheader: {
    loginout: "退出登录",
    login: "登录",
    register: "注册",
    totalone: "24H交易总量",
    totaltwo: "24H智能交易量",
    totalthree: "24H机器人交易量",
    totalfour: "24H返佣总额",
    totalfive: "24H做市商成交量",
    referral: "邀请推荐",
    AllRead: "全部已读",
    NoMore: "没有更多了",
    TradeMessage: "交易通知",
    Announcement: "公告",
    loadMore: "加载更多",
    SystemMessage: "系统消息",
  },
  components_mysymbolselect: {
    search: "搜索",
  },
  views_signup: {
    email: "邮箱",
    phone: "手机",
    signup_input_userName: "请输入账号",
    signup_input_userName_placeholder_email: "请输入邮箱",
    signup_input_userName_placeholder_phone: "请输入手机号",
    signup_input_userName_placeholder_Password: "请输入密码",
    signup_input_userName_placeholder_confirmPassword: "请确认密码",
    signup_input_userName_placeholder_inviteCode: "请输入邀请码",
    signup_input_userName_placeholder_VerificationCode: "请输入验证码",
    signup_input_userName_placeholder_Code: "获取验证码",
    signup_register: "注册",
    signup_login: "使用已有账户登录",
    signup_signup_success: "注册成功",
    signup_email_phone: "注册邮箱/手机号",
    signup_back_login: "返回登录",
    signup_please_input_password: "请输入密码",
    signup_please_input_size_password: "请输入长度为8-20位的密码",
    signup_please_input_confirm_password: "请输入确认密码",
  },
  user_info: {
    AccountManagement: "账户管理",
    Phone: "手机",
    Level: "账户等级",
    Type: "账户类型",
    LoginLog: "登录日志",
    Add: "新增",
    Exchange: "交易所",
    AccountName: "账户名",
    APIKEY: "账户APIKEY",
    Secretkey: " 账户secretkey",
    ExpirationTime: "过期时间",
    PermissionList: "权限列表",
    IPList: "IP列表",
    CreateTime: "创建时间",
    UpdateTime: "更新时间",
    Action: "操作",
    ViewBalance: "查看余额",
    Edit: "编辑",
    Delete: "删除",

    AssetsManagement: "资产分析",
    FinancialAnalysis: "财务分析",

    StrategyAnalysis: "策略分析",
    SelectExchange: "选择交易所",
    SelectStrategyType: "选择策略类型",
    SumQty: "总成交额",
    TotalSumQty: "累计成交额",
    SumCost24H: "24H资金成本",
    SumQty24H: "24H成交额",
    MaxHold24H: "24H最大持仓",
    MaxHoldLong24H: "24H最大持仓(多)",
    MaxHoldShort24H: "24H最大持仓(空)",
    SumNetProfit24H: "24H已实现盈亏",
    SumUnrealizedProfit24H: "24H未实现盈亏",
    SumTotalProfit24H: "24H总盈亏",
    ProfitAndMaxDrawDownChart: "收益和最大回撤",
    NetProfitRate24H: "24H收益率",
    SumNetProfitRate: "累计收益率",
    LowWater: "低水位",
    MaxDrawDown24H: "24H最大回撤",

    NetValueChart: "复合收益率",
    DrawDownChart: "回撤曲线",
    ProfitChart: "盈亏曲线",
    NetValue: "资产净值",
    HighWater: "高水位",

    DrawDown: "回撤",
    Profit: "盈亏",
    TotalProfit: "累计盈亏",

    Date: "时间",
    Return: "收益率",
    TotalReturn: "累计收益率",
    GrossReturn: "毛收益率",
    Nav: "净值",
    Balance: "余额",
    Transfer: "划转",
    LastUpdateTime: "最后更新时间",

    AnnualReturn: "年化收益率",
    AnnualVolatility: "年化波动率",
    SharpeRatio: "夏普比率",
    MaxDrawDown: "最大回撤",

    Hour: "小时",
    Day: "日",
    Week: "周",
    Month: "月",
    Year: "年",
    TIME_7D: "7天",
    TIME_30D: "30天",
    TIME_90D: "90天",
    TIME_180D: "半年",
    TIME_365D: "一年",
    OTHER: "自定义",

    AllAccount: "全部账户",
    AllSourceAsset: "全部统计源",
    SelectAccountType: "选择账户类型",
    SelectSourceAsset: "选择统计源",
    SelectTimeRange: "选择时间范围",
    SelectTimeDuration: "选择时间间隔",
    SelectSubAccount: "选择子账户",
    SelectStatisticsCurrency: "选择统计币种",

    LastDayPnL: "昨日盈亏",
    LastWeekPnL: "7天盈亏",
    LastMonthPnL: "30天盈亏",
    Chart: "图表",
    DailyPnL: "每日收益",
    CumulativePnL: "累计收益",
    PnLDistribution: "收益分布",
    Smart: "智能交易",
    Bots: "机器人",
    AssetsDistribution: "资产分布",
    PositionDistribution: "持仓分布",

    Traders: "交易员",
    Observer: "观察者",
    Risk: "风控账号",
    ToVerify: "去验证",
    ConfirmDelete: "是否确认删除？",
    ConfirmDeleteTips: "此操作无法撤销！",
    Confirm: "确定",
    Cancel: "取消",

    AccountBalance: "账户余额",
    Currency: "币种",

    AccountType: "账户类型",
    AvailableBalance: "可用余额",
    LockBalance: "锁定余额",
    MarginBalance: "保证金余额",
    WalletBalance: "钱包余额",
    MaxTransferableBalance: "最大可转出余额",
    Total: "总计",
    Record: "条记录",

    Account: "账户",
    LoginIP: "登录IP",
    LoginTime: "登录时间",

    ApiKey: {
      ApiForm: {
        NewAccount: "新增账户",
        EditAccount: "编辑账户",
        AccountName: "账户名",
        Exchange: "交易所",
        AccountApiKey: "账户API KEY",
        AccountSecretKey: "账户SECRET KEY",
        AccountPassPhrase: "账户Passphrase",
        AuthList: "权限列表",
        SpotTrade: "现货交易",
        FutureTrade: "合约交易",
        Reset: "重置",
        Rule: {
          NameMsg: "请输入账户名",
          ExchangeMsg: "请选择交易所",
          ApiKeyMsg: "请输入ApiKey",
          SecretKeyMsg: "请输入SecretKey",
          PassPhraseMsg: "请输入PassPhrase",
          AuthListMsg: "请选择权限",
          FuturesmktPwdMd5Invalid: "须为 32 位小写十六进制 MD5",
        },
        Confirm: "确定",
        Cancel: "取消",
        Futuresmkt: {
          AccountNo: "资金账号",
          PwdMd5: "登录密码 MD5",
          OrgCode: "机构代码",
          OrgCodeOptional: "选填，如 trade",
        },
      },
    },
  },
  data_info: {
    Data: "数据",
    Greedindex: "贪婪指数",
  },
  setting_info: {
    Navigator: "导航栏",
    System: "系统设置",
    Language: "语言设置",
    Currency: "货币设置",
    TimeZone: "时区选择",
    Notice: "通知设置",
    Trade: "交易通知",
    OpenTradeNotice: "是否开启交易通知",
    Announcement: "公告通知",
    OpenAnnouncementNotice: "是否开启交易通知",
    ON: "开",
    OFF: "关",
    Security: "安全设置",
    BindEmail: "绑定邮箱",
    BindedEmai: "已绑定邮箱",
    SMSVerification: "短信验证",
    EffectivelyProtectAccountSecurity: "短信验证可有效保护账户安全",
    EmailVerification: "邮箱验证",
    EffectivelyProtectEmailSecurity: "邮箱验证可有效保护账户安全",
    BindIP: "绑定IP",
    BindedIP: "已绑定IP",
    Change: "修改",
    ChangePassword: "修改密码",
    LanguageSetting: {
      SimplifiedChinese: "简体中文",
      TraditionalChinese: "繁體中文",
      English: "English",
    },
    SecuritySetting: {
      AccountPassword: "账户密码",
      PasswordLevel: "当前密码强度",
      PasswordLevelLow: "低",
      PasswordLevelMedium: "中",
      PasswordLevelHigh: "高",
    },

    PlaceHolderText: {
      OldPassword: "请输入旧密码",
      NewPassword: "请输入新密码",
      ConfirmPassword: "请确认新密码",
    },
  },
  PlaceHolderText: {
    Cancel: "取消",
    Confirm: "确定",
  },
  Dictionary: {
    EXECUTING: "正在执行",
    EXECUTED: "执行成功",
    CANCELING: "正在撤销",
    CANCELED: "已撤销",
    EXECUTION_ERROR: "执行错误",
    OPEN: "开仓",
    CLOSE: "平仓",
    BUY: "买入",
    SELL: "卖出",
    LONG: "多",
    SHORT: "空",
    BOTH: "双向",
    NORMAL_MODE: "正常模式",
    FILLED: "完全成交",
    LIMIT: "限价",
    MARKET: "市价",
    STOP_MARKET: "市价止损",
    TAKE_PROFIT_MARKET: "市价止盈",
    TAKE_PROFIT: "止盈",
    STOP_LOSS: "止损",
    PARTIALLY_FILLED: "部分成交",
    TRADING: "交易中",
    DIRECT_MODE: "直接模式",
    BINANCE_FUNDING: "资金",
    BINANCE_SPOT: "现货",
    BINANCE_MARGIN_CROSSED: "全仓杠杆",
    BINANCE_MARGIN_ISOLATED: "逐仓杠杆",
    BINANCE_FUTURE: "U本位合约",
    BINANCE_SWAP: "币本位合约",
    SPOT: "现货",
    SWAP: "币本位合约",
    FUTURE: "U本位合约",
    LINEAR: "U本位合约",
    INVERSE: "反向合约",
    spot: "现货",
    swap: "永续合约",
    linear: "U本位合约",
    inverse: "反向合约",
    OKX_SPOT: "现货",
    OKX_MARGIN: "现货杠杆",
    OKX_SWAP: "永续合约",
    OKX_FUTURES: "交割合约",
    OPTION: "期权",
    INDEX: "指数",
    FUTURES: "期货",
    FOREX: "外汇",
    ASTOCK: "A股",
    EXECUTION_TIMEOUT: "执行超时",
    UNFILLED: "未成交",
    CONDITIONAL: "单向", // okx 策略委托单向止盈止损 conditional
    OCO: "双向", // okx 策略委托双向止盈止损 oco
    CONDITIONAL_OCO: "单向/双向",
    TRIGGER_ORDER_LIMIT: "条件委托限价",
    TRIGGER_ORDER_MARKET: "条件委托市价",
    TP_TRIGGER_PRICE: "止盈触发价",
    TP_ORDER_PRICE: "止盈委托价",
    TP_LIMIT: "限价止盈",
    TP_MARKET: "市价止盈",
    SL_TRIGGER_PRICE: "止损触发价",
    SL_ORDER_PRICE: "止损委托价",
    SL_LIMIT: "限价止损",
    SL_MARKET: "市价止损",
    WAITING: "待触发",
    EXPIRED: "失效",
    PLACE_ORDER: "挂单",
    FAILURE: "失败",
    PREPARING: "准备中",
    STOPPED: "已停止",
    STOPPING: "停止中",
    BACKTEST_FINISHED: "回测完成",
    TRADING_HALTED: "交易中止",
    SELL_CLOSE: "卖出平仓",
    SELL_OPEN: "卖出开仓",
    BUY_CLOSE: "买入平仓",
    BUY_OPEN: "买入开仓",
    CLOSE_LONG: "平多",
    CLOSE_SHORT: "平空",
    INTERRUPTED: "中断",

    UNIFIED: "统一账号",
    CONTRACT: "合约账号",

    SAT_BINANCE_SPOT: "现货",
    SAT_BINANCE_MARGIN_CROSSED: "全仓杠杆",
    SAT_BINANCE_MARGIN_ISOLATED: "逐仓杠杆",
    SAT_BINANCE_FUTURE: "U本位合约",
    SAT_BINANCE_SWAP: "币本位合约",

    SAT_OKX_SPOT: "现货",
    SAT_OKX_SWAP: "永续合约",
    SAT_OKX_FUTURES: "交割合约",

    SAT_BYBIT_spot: "现货",
    SAT_BYBIT_linear: "U本位合约",
    SAT_BYBIT_inverse: "反向合约",

    SAT_GATE_spot: "现货",
    SAT_GATE_futures: "永续合约",
    SAT_GATE_delivery: "交割合约",

    SAT_ASTER_SPOT: "现货",
    SAT_ASTER_FUTURE: "U本位合约",

    AAT_BINANCE_FUNDING: "资金账户",
    AAT_BINANCE_SPOT: "现货账户",
    AAT_BINANCE_MARGIN_CROSSED: "全仓杠杆账户",
    AAT_BINANCE_MARGIN_ISOLATED: "逐仓杠杆账户",
    AAT_BINANCE_FUTURE: "U本位合约账户",
    AAT_BINANCE_SWAP: "币本位合约账户",
    AAT_BINANCE_PORTFOLIO_MARGIN: "统一账户",

    AAT_BYBIT_FUNDING: "资金账户",
    AAT_BYBIT_UNIFIED: "统一账户",
    AAT_BYBIT_CONTRACT: "合约账户",

    AAT_OKX_FUNDING: "资金账户",
    AAT_OKX_SPOT: "交易账户",

    AAT_GATE_spot: "现货账户",
    AAT_GATE_futures: "永续合约账户",
    AAT_GATE_delivery: "交割合约账户",
    AAT_GATE_unified: "统一账户",
    AAT_GATE_margin: "逐仓杠杆账户",
    AAT_GATE_cross_margin: "全仓杠杆账户",

    AAT_ASTER_SPOT: "现货账户",
    AAT_ASTER_FUTURE: "U本位合约账户",

    SUNX_swap: "永续合约",
    SUNX_SWAP: "永续合约",
    SAT_SUNX_SWAP: "永续合约",
    AAT_SUNX_SWAP: "永续合约账户",

    FUTURESMKT_UNIFIED: "期货统一账户",
    FUTURESMKT_CBOT: "CBOT",
    FUTURESMKT_CME: "CME",
    FUTURESMKT_COMEX: "COMEX",
    FUTURESMKT_EUREX: "EUREX",
    FUTURESMKT_HKEX: "HKEX",
    FUTURESMKT_NYMEX: "NYMEX",
    FUTURESMKT_SGX: "SGX",

    XCOIN_spot: "现货",
    XCOIN_linear_perpetual: "永续",
    XCOIN_linear_futures: "交割",

    BITGET_SPOT: "现货",
    BITGET_MARGIN_CROSSED: "全仓杠杆",
    BITGET_MARGIN_ISOLATED: "逐仓杠杆",
    "BITGET_USDT-FUTURES": "U本位永续合约",
    "BITGET_COIN-FUTURES": "币本位永续合约",
  },
  Modal: {
    EmptyModal: {
      Message: "暂无数据",
    },
    InviteModal: {
      Invite: "邀请",
      Cancel: "取消",
      RateOfReturn: "收益率",
      InviteCode: "邀请码",
      Copy: "复制",
      JoinCryptoJourney: "邀请好友，共享策略交易！",
      ShareLink: "分享链接",
      ShareOn: "分享到",
      NoInviteCode: "邀请码不存在",
      InviteCodeCopied: "邀请码已复制",
      InviteLinkCopied: "邀请链接已复制",
      CopyFailed: "复制失败，请重试",
      ScanQRCode: "请使用微信扫描二维码",
      ShareText: "我在使用TradingX进行加密货币交易，快来一起加入吧！",
      Loading: "加载中...",
    },

    DeribitModal: {
      Cancel: "取消",
      Call: "看涨",
      Put: "看跌",
      Amount: "数量",
      Position: "持仓",
      LimitPrice: "限价",
      AdvancedOrderForm: "高级委托",
      TimeInForce: "有效方式",
      Reduce: "只减仓",
      Post: "只做Maker",
      BuyMargin: "买入保证金",
      SellMargin: "卖出保证金",
      ContractDetails: "合约详情",
      PriceSource: "价格来源",
      ContractSize: "合约大小",
      MinOrderSize: "最小下单量",
      TickSize: "最小变动价位",
      SettlementCurrency: "结算货币",
      ExpiryDate: "到期日",
      MinSellPrice: "最小卖出价格",
      MaxBuyPrice: "最大买入价格",
      Delta: "Delta",
      Gamma: "Gamma",
      Vega: "Vega",
      Theta: "Theta",
      Rho: "Rho",
      OrderBook: "订单簿",
      MarkPrice: "标记价格",
      the24hLow: "24h最低价",
      the24hHigh: "24h最高价",
      the24hVolume: "24h成交量",
      the24hChange: "24h涨跌幅",
      Total: "总计",
      Sum: "合计",
      AvgPrice: "均价",
      BidSize: "买入量",
      BidPrice: "买入价",
      AskPrice: "卖出价",
      AskSize: "卖出量",
      RecentTrade: "最新成交",
      Chart: "图表",
      Buy: "买入",
      Sell: "卖出",
      RecentSevenDays: "近7天",
      RecentOneMonth: "近1个月",
      RecentThreeMonths: "近3个月",
      AllTime: "全部时间",
    },
    WarningModal: {
      PriceAlert: "价格预警",
      Monitoring: "监控中",
      MonitoringRecord: "监控记录",
      NewAlert: "新建预警",
      Cancel: "取消",
      PriceAlertSettings: "价格预警设置",
      Save: "保存",
      Load: "加载",
      TransactionType: "交易类型",
      PleaseSelect: "请选择",
      NewestPrice: "最新价格",
      TriggerPrice: "触发价格",
      DownTo: "下跌至",
      UpTo: "上涨至",
      RangePrice: "区间价",
      Amplitude: "振幅",
      WarningDuration: "预警时长",
      Alert: "预警",
      ExpirationTime: "失效时间",
      OneMinute: "1分钟",
      CloseManually: "手动关闭",
      WebSide: "Web端",
      AppSide: "App端",
      TriggeringConditions: "触发条件",
      PriceAtSetup: "设置时价格",
      CreatedOrExpired: "创建时间/过期时间",
      Status: "状态",
      Action: "操作",
      EffectiveTime: "生效时间",
    },
    LeverModal: {
      LevelTransfer: "杠杆划转",
      Transfer: "划转",
      Cancel: "取消",
      From: "从",
      To: "至",
      Currency: "币种",
      AvailableFunds: "可用资金",
      TransferAmount: "划转数量",
      All: "全部",
      IsolateAccount: "逐仓账户",
      FullAccount: "全仓账户",
      SpotAccount: "现货账户",
    },
    AIModal: {
      Spot: "现货",
      Isolate: "逐仓",
      Full: "全仓",
      BrrowAndRepay: "借/还",
      PleaseLogin: "请先登录！",
    },
    CiculateModal: {
      Spot: "现货",
      Isolate: "逐仓",
      Full: "全仓",
      MarginBrrowAndRepay: "杠杆借还",
      Confirm: "确定",
      Cancel: "取消",
      LoanAmount: "借款数量",
      CurrentlyAvailableToBorrowTips:
        "系统可借充足情况下用户账户当前最大可借额度",
      CurrentlyAvailableToBorrow: "当前可借",
      MaxAvailableToBorrowTips: "平台限制的用户当前等级可以借的额度",
      MaxAvailableToBorrow: "最大可借",
      HourlyInterestRate: "小时利率",
      HourlyInterestRateTips:
        "借入资产时会立即产生1小时的利息，并且每小时会记息一次(不满一小时按一小时计算)",
      Loan: "借款",
      Repay: "还款",
      Available: "可用",
      Borrowed: "已借",
      NetAssets: "净资产",
      CurrentInterest: "当前利息",
      RepaymentAmount: "还款数量",
      MaximumRepayable: "最大可还",
      OperationSuccessful: "操作成功",
      OperationFailed: "操作失败",
    },
    LeverageToolsModal: {
      Isolate: "逐仓",
      Full: "全仓",
      MarginModel: "保证金模式",
      Confirm: "确定",
      MarginModelTips1: "调整保证金模式仅对当前合约生效。",
      FullMarginTipsTitle: "全仓保证金模式:",
      FullMarginTipsContent:
        "保证金资产相同的全仓仓位共享该资产的全仓保证金。在强平事件中，交易者可能会损失全部该保证金和该保证金资产下的所有全仓仓位。",
      IsolateMarginTipsTitle: "逐仓保证金模式:",
      IsolateMarginTipsContent:
        "一定数量保证金被分配到仓位上。如果仓位保证金亏损到低于维持保证金的水平，仓位将被强平。在逐仓模式下，您可以为这个仓位添加和减少保证金。",
      Cancel: "取消",
      LeverageSetting: "杠杆率设置",
      CurrentLeveragePosition: "当前杠杆倍数最高可持有头寸",
      CurrentLeveragePositionTips1: "杠杆调整将同时影响当前仓位和挂单的杠杆。",
      CurrentLeveragePositionTips2:
        "选择超过 [10x] 杠杆交易会增加强行平仓风险，请注意相关风险。",
      ModelSetting: "模式设置",
      PositionModel: "仓位模式",
      OneWayPosition: "单向持仓",
      OneWayPositionTips: "单向持仓模式下，一个合约只允许持有一个方向的仓位。",
      TwoWayPosition: "双向持仓",
      TwoWayPositionTips:
        "双向持仓模式下，一个合约可允许同时持有多空两个方向的仓位，并且同一合约下不同方向仓位风险对冲。",
      AssetModel: "资产模式",
      SingleModel: "单币种保证金模式",
      SingleModelTips1: "仅支持使用合约的保证金资产交易U本位合约。",
      SingleModelTips2: "保证金资产相同的全仓仓位间盈亏互相抵消。",
      SingleModelTips3: "支持全仓和逐仓。",
      CombineModel: "联合保证金模式",
      CombineModelTips1: "可跨保证金资产交易U本位合约。",
      CombineModelTips2: "不同保证金资产全仓仓位间盈亏相互抵消。",
      CombineModelTips3: "目前仅支持全仓。",
      PleaseSelectApi: "请先设置API",
      ActionSuccessful: "操作成功",
      ActionFailed: "操作失败",
    },
    UserCountModal: {
      SelectSubAccount: "选择交易子账户",
      Save: "保存",
      Cancel: "取消",
      SelectExchange: "选择交易所",
      All: "全部",
      Main: "主",
      Ratio: "比例",
      MaxQty: "最大金额",
      MaxQtyTips: "请输入最大可用金额",
      SyncRatio: "同步比例",
      AvailableBalance: "可用余额",
      WalletBalance: "钱包余额",
      ErrMsg: "错误的api key，请检查此账户设置!",
    },
    TransferModal: {
      UniversalTransfer: "万向划转",
      AssetTransfer: "资金划转",
      Transfer: "划转",
      TransferHistory: "划转记录",
      Cancel: "取消",
      AccountSelect: "账户选择",
      From: "从",
      To: "至",
      Currency: "币种",
      AvailableFunds: "可用资金",
      TransferAmount: "划转数量",
      All: "全部",
      SpotAccount: "现货账户",
      FutureAccount: "U合约账户",
      SwapAccount: "币合约账号",
      FundsAccount: "资金账户",
    },
  },

  AIDashboard: {
    AIDashboardDetail: {
      Group: "交易分组",
      Export: "导出Excel",
      Search: "搜索",
      Optional: "自选",
      Market: "市场",
      Symbol: "交易对",
      Sort: "排名",
      Price: "价格",
      UpDown: "涨跌",
      TREND: "趋势工具",
      STRONG_BACK: "强势高抛低吸",
      SHOCK_GRID: "震荡网格",
      ARB_SPREAD: "价差套利",
      ARB_STAT: "统计套利",
      SMART_EXECUTE: "执行工具",
      ARB_FUNDING: "智能资费套利",
      SMART_SHOCK_GRID: "智能震荡网格",
      SHOCK_REVERSE: "高抛低吸",
      MARKETMAKER: "做市商策略",
      RL_MARKETMAKER: "强化做市商",
      MmTargetSingle: "单一标的",
      MmTargetPair: "配对标的",
      MmPairNotSelectedMsg: "请先选择配对标的",
      MmPairResolveFailedMsg: "配对合约解析失败，请稍后重试",
      MmPairNotFoundMsg: "未找到对应配对，已切换为单一标的",
      SOR: "智能执行",
      SOR_DIRECT: "正向套利",
      SOR_INVERSE: "反向套利",
      SOR_DELIVERY: "交割套利",
      SOR_ARB: "资金费套利",
      ARB_OPTION: "期权套利",
      ARB_FACTOR: "统计套利",
      ASTOCK_EXECUTE_MULTI: "A股执行",
      TREND_CONTINUE_ROBOT: "趋势二波",
      RATE_GRID: "汇率网格",
      STRONG_GRID: "强势网格",
      TER: "趋势延续",
      TerMode: "风险模式",
      TerModeBalance: "稳健",
      TerModeAggressive: "进取",
      TerMakerOnly: "只做 Maker",
      TerMaxTradeQty: "可用金额",
      TerBalance: "结余",
      TerEquity: "净值",
      TerSymbolHint:
        "仅支持币安 U 本位 XAUUSDT 与 OKX 永续 XAU-USDT-SWAP，且账户为全仓。品种不符时由策略端返回错误。",
      VOLUME_LATTICE: "量格",
      VolumeLatticeMaxTradeQty: "可用金额",
      VolumeLatticeInitialQty: "初始单量",
      VolumeLatticeBalance: "结余",
      VolumeLatticeEquity: "净值",
      VolumeLatticeSymbolHint:
        "仅支持币安 U 本位 XAUUSDT 与 OKX 永续 XAU-USDT-SWAP。账户须为双向持仓、多空全仓，且该品种当前无持仓。初始单量是 XAU 基础币数量，不是张数。格子距离、止损、止盈与锁利由策略固定。不符时由策略端返回错误。",
      MarkPrice: "标记价格",
      The24hHigh: "24H最高价",
      The24hLow: "24H最低价",
      The24hVolume: "24H成交量",
      The24hQty: "24H成交额",
      SelectEnvironment: "选择运行环境",
      TestEnvironment: "测试环境",
      ProductionEnvironment: "生产环境",
      AwsEnvironment: "AWS环境",
      LinodeEnvironment: "Linode环境",
      Linode2Environment: "Linode2环境",
      Local211Environment: "本地211环境",
      SelectSubAccount: "选择子账户",
      PleaseCancelUpdate: "请先取消更新",
      UnknownStrategyMsg: "未知策略",
      StartSuccessfulMsg: "启动成功",
      StartFailedMsg: "启动失败",
      UpdateSuccessfulMsg: "更新成功",
      UpdateFailedMsg: "更新失败",
      UnknownSymbolMsg: "未知交易对",
      GetSubscribeListFailed: "获取用户订阅列表失败",
      Number: "序号",
      Unfold: "展开",
      BatchDelete: "批量删除",
      ClearSelected: "清空选择",
    },
    KChart: {
      HistoryMarks: "历史委托",
      CurrentMarks: "当前委托",
    },
    Form: {
      MaxOrderAmount: "最大单量",
      MinOpenSpread: "最低开仓价差",
      MinCloseSpread: "最低平仓价差",
      ImpactLevel: "档量",
      ImpactMultiple: "倍率 x",
      ImpactNumPerMinute: "冲击数/分钟",
      Auto: "自动",
      Manual: "手动",
      Level: "档",
      LevelSetting: "订单设置",
      LevelStart: "开始位置",
      LevelTotal: "挂单数",
      LevelInterval: "价格间隔",
      PositionSetting: "仓位设置",
      ArbStatFuturesMarketSizingMode: "对冲模式",
      ArbStatFuturesMarketSizingModeNotionalFirst: "不限制",
      ArbStatFuturesMarketSizingModeDiscreteNeutral: "非对冲时拒开",
      ArbStatFuturesMarketMaxLotSkewRatio: "对冲单边敞口暴露上限",
      ArbStatFuturesMarketMaxLotSkewRatioInvalid:
        "对冲单边敞口暴露上限须为不小于 0 的有效百分比。",
      MultiplePositionsAvailable: "多头头寸",
      ShortPositionAvailable: "空头头寸",
      TargetPosition: "目标仓位",
      AmountAvailable: "可用资金",
      AllAmountAvailable: "总可用资金",
      AvailableAmountOnce: "单次可用",
      RobotN: "只交易流动性前n名",
      PitchRatio: "间距比例",
      OrderStep: "拆单间距",
      OrderQuantity: "委托量",
      Isolate: "逐仓",
      Cross: "全仓",
      Spot: "现货",
      Available: "可用",
      Borrowed: "已借",
      IsolatedMarginNetAssets: "逐仓净资产",
      CrossMarginNetAssets: "全仓净资产",
      SpotNetAssets: "现货余额",
      CanBeOpened: "可开",
      Balance: "余额",
      CustomInstanceName: "自定义实例名称",
      Reset: "重置",
      Cancel: "取消",
      NotLoggedIn: "未登录",
      InsufficientVipLevel: "交易锁定",
      Startup: "启动",
      Update: "更新",
      SmartPrice: "SPF",
      Gear: "档位",
      Window: "窗口",
      Cycle: "周期",
      LongCycle: "长周期",
      ShortCycle: "短周期",
      PriceGap: "价格间距",
      Minimum: "最小",
      Maximum: "最大",
      Volatility: "波动率",
      Trend: "趋势",
      OrderBook: "OIF",
      OFIF: "OFIF",
      MaximumInventory: "最大库存",
      EnableCombination: "启用组合",
      EnableTimeSharing: "启用分时",
      EnableHedge: "启用对冲",
      ExecMode: "执行模式",
      ExecModeLive: "实盘",
      ExecModeSim: "模拟",
      EnableLiquidation: "启用流动性",
      LiquidationRatio: "流动性倍率",
      Clearance: "清仓",
      AllClearance: "全部清仓",
      OnlyMaker: "只做Maker",
      IsReplay: "回测模式",
      ReplayStartTime: "回放开始时间",
      ReplayEndTime: "回放结束时间",
      ReplaySpeed: "回放倍速",
      ArbStatManualParamsSection: "协整参数设定",
      ArbStatSectionSignalOpenConfirm: "信号周期与开仓确认",
      ArbStatSectionCopula: "Copula 开仓与平仓阈值",
      ArbStatSectionCointPnl: "协整仓位、动态止盈与时间限制",
      ArbStatSectionRunReplay: "执行、回测与实例",
      ArbStatTwapUse: "使用 TWAP（Maker 切片）",
      ArbStatTwapWindowSec: "TWAP 窗口",
      ArbStatTwapSliceCount: "TWAP 分片数",
      ArbStatTwapMakerPlacementMode: "Maker 挂单模式",
      ArbStatTwapMakerPlacementModeSingle: "一档模式",
      ArbStatTwapMakerPlacementModeMultiLevel: "前 N 档模式",
      ArbStatTwapMakerPlacementModeAdaptive: "智能模式",
      ArbStatTwapMakerDepthLevels: "挂档数",
      ArbStatTwapNotionalBoundsEnabled: "启用名义上下限",
      ArbStatTwapSliceMinNotional: "分片最小名义",
      ArbStatTwapSliceMaxNotional: "分片最大名义",
      ArbStatTwapOrderMinNotional: "挂单最小名义",
      ArbStatTwapOrderMaxNotional: "挂单最大名义",
      ArbStatTwapOrderMaxNotionalJitterMinRatio: "挂单最大名义抖动下界比例",
      ArbStatTwapAdaptiveNotionalMultEnabled: "启用动态名义倍率",
      ArbStatTwapAdaptiveNotionalMultMax: "动态名义倍率上限",
      ArbStatSimFillMode: "模拟成交模式",
      ArbStatSimFillModeQueue: "队列模式",
      ArbStatSimFillModeTradeCross: "成交穿越模式",
      ArbStatMaxMakerFeeRate: "maker费率上限",
      ArbStatMaxMakerFeeRateHint: "在 maker 手续费率高于此限制时不开仓。",
      ArbStatTwapParamsInvalid:
        "TWAP：窗口须至少 1 秒；分片数须为不小于 1 的整数；前 N 档模式下挂档数须为 2～5；启用名义上下限时各名义值须为正数且最小值小于最大值。",
      SecondsUnit: "秒",
      ArbStatSubpanelDynamicPnl: "动态止盈止损参数",
      ArbStatPeriods: "信号周期",
      ArbStatCopulaMinConfirmPeriods: "开仓确认最少周期数",
      ArbStatConfirmPeriodSetWhitelist: "开仓确认周期组合白名单",
      ArbStatConfirmPeriodSetHint:
        "不添加任何组合表示不限制。每行选一个周期组合；顺序仅影响展示，提交时按信号周期顺序规范化。",
      ArbStatConfirmPeriodSetAdd: "添加组合",
      ArbStatConfirmPeriodSetRemove: "删除",
      ArbStatConfirmPeriodSetTooFew:
        "白名单每一行的周期数量不能少于开仓确认最少周期数，至少 {min} 个。",
      ArbStatConfirmPeriodWhitelistSwitch: "启用组合白名单",
      ArbStatConfirmPeriodComboAdd: "添加",
      ArbStatConfirmPeriodWhitelistNeedOne:
        "已启用组合白名单时，请至少添加一个有效组合，或关闭开关。",
      ArbStatConfirmPeriodComboDuplicate: "该组合已添加。",
      ArbStatConfirmPeriodComboNeedSelect: "请先在选项框中选择周期。",
      ArbStatExcludePairsWhitelist: "排除交易对组合",
      ArbStatExcludePairsHint:
        "选择要暂时排除的配对组合，被排除的组合不参与套利开仓。",
      ArbStatExcludePairsWhitelistSwitch: "启用排除组合",
      ArbStatExcludePairsComboAdd: "添加",
      ArbStatExcludePairsComboDuplicate: "该组合已添加。",
      ArbStatExcludePairsComboNeedSelect: "请先在选项框中选择组合。",
      ArbStatSymbolsNeedThree: "参与套利的交易对须为 3 条，且与侧栏池一致。",
      ArbStatSymbolsNeedTwo: "参与套利的交易对至少需要 2 条。",
      ArbStatNeedTradablePair: "至少需要一对两腿都有非 0 API 的可交易组合。",
      ArbStatApiSetting: "API 设置",
      ArbStatNoTradeAccount: "不交易（仅进 Copula）",
      ArbStatBitgetHint:
        "Bitget 仅支持 Classic 双向持仓，账户类型须为 USDT-FUTURES；UTA 会启动失败。",
      ArbStatLegacyInstanceHint:
        "当前参数为旧格式，已转换为新契约。请停止原实例后点击启动以创建新实例，无法热更新。",
      ArbStatMemberKeyInvalid: "配对身份无法解析，请更换配对。",
      ArbStatCopulaEntryThreshold: "开仓水位",
      ArbStatCopulaMinRho: "最小相关性",
      ArbStatDynThresholdK: "动态阈值系数 K",
      ArbStatDynThresholdBlend: "动态阈值混合权重",
      ArbStatCopulaExitThreshold: "信号回归阈值",
      ArbStatCopulaRevertMinProfitEnabled: "回归平仓要求最低浮盈",
      ArbStatCopulaRevertMinProfitFrac: "回归最低浮盈比例",
      ArbStatCopulaRevertMinProfitParamsInvalid:
        "回归最低浮盈比例须在 [0, 1] 内（含 0）。",
      ArbStatRhoDropThreshold: "相关性降低比例",
      ArbStatCopulaEntryPullbackFrac: "信号回落比例",
      ArbStatCopulaEntryPullbackMinPoints: "信号最小数据点",
      ArbStatCopulaEntryPullbackPeakMinAge: "峰值门控数据点",
      ArbStatCopulaEntryEwmaSlopeLagSlots: "斜率回归数据点",
      ArbStatCopulaReopenAfterLossNeedNeutral: "止损需回归中性",
      ArbStatCopulaEntryKlineFactorFilters: "开仓 K 线因子过滤",
      ArbStatCopulaEntryKlineFactorFiltersHint:
        "空列表表示不启用；多条规则按顺序 AND。每条规则对应一个周期与因子类型。",
      ArbStatCopulaEntryKlineFilterItemTitle: "规则 {index}",
      ArbStatCopulaEntryKlineFilterAdd: "添加规则",
      ArbStatCopulaEntryKlineFilterRemove: "删除",
      ArbStatCopulaEntryKlineFilterFactorType: "因子类型",
      ArbStatCopulaEntryKlineFilterFactorType_sma: "SMA",
      ArbStatCopulaEntryKlineFilterFactorType_ema: "EMA",
      ArbStatCopulaEntryKlineFilterFactorType_wma: "WMA",
      ArbStatCopulaEntryKlineFilterFactorType_vwma: "VWMA",
      ArbStatCopulaEntryKlineFilterFactorType_cci: "CCI",
      ArbStatCopulaEntryKlineFilterFactorType_rsi: "RSI",
      ArbStatCopulaEntryKlineFilterFactorType_natr_expand:
        "ATR 膨胀 / natr_expand",
      ArbStatCopulaEntryKlineFilterFactorType_ma_cross: "MA 交叉",
      ArbStatCopulaEntryKlineFilterFactorType_stoch_rsi: "Stoch RSI",
      ArbStatCopulaEntryKlineFilterStochHint:
        "在价比已收盘 K 线上计算 K/D。超买只放行做空价比，超卖只放行做多价比。全表最多一条。",
      ArbStatCopulaEntryKlineFilterStochRsiLength: "RSI 周期",
      ArbStatCopulaEntryKlineFilterStochLength: "Stoch 周期",
      ArbStatCopulaEntryKlineFilterStochSmoothK: "Smooth K",
      ArbStatCopulaEntryKlineFilterStochSmoothD: "Smooth D",
      ArbStatCopulaEntryKlineFilterStochExitHint:
        "始终保存并校验。只有选择独立平仓或跟随信号时才参与平仓；平仓交叉只追加 K 与 D，本身不打开平仓。",
      ArbStatCopulaEntryKlineFilterStochExitShort: "做空反转 K 低于",
      ArbStatCopulaEntryKlineFilterStochExitLong: "做多反转 K 高于",
      ArbStatCopulaEntryKlineFilterStochInvalid:
        "Stoch RSI 周期无效：RSI / Stoch 须为 2–500 的整数，Smooth K / D 须为 1–50 的整数，不能为 0",
      ArbStatCopulaEntryKlineFilterStochRangeInvalid:
        "Stoch RSI 阈值无效：须满足 0 ≤ 下限 < 上限 ≤ 100，做空出场 K < 上限，做多出场 K > 下限，且做空出场 K < 做多出场 K",
      ArbStatCopulaEntryKlineFilterStochDuplicate: "Stoch RSI 最多一条",
      ArbStatCopulaEntryKlineFilterMaCrossFastType: "快线类型",
      ArbStatCopulaEntryKlineFilterMaCrossFastLength: "快线周期",
      ArbStatCopulaEntryKlineFilterMaCrossSlowType: "慢线类型",
      ArbStatCopulaEntryKlineFilterMaCrossSlowLength: "慢线周期",
      ArbStatCopulaEntryKlineFilterMaCrossInvalid:
        "MA 交叉配置无效：快慢线类型须为 sma/ema/wma/vwma，快线周期 >= 2，慢线周期 >= 2",
      ArbStatCopulaEntryKlineFilterPeriod: "K 线周期",
      ArbStatCopulaEntryKlineFilterLengths: "均线长度",
      ArbStatCopulaEntryKlineFilterLengthItem: "长度 {index}",
      ArbStatCopulaEntryKlineFilterLengthAdd: "添加长度",
      ArbStatCopulaEntryKlineFilterLengthRemove: "删除",
      ArbStatCopulaEntryKlineFilterLengthsHint:
        "须严格递增，至少 2 项；SMA/EMA/WMA/VWMA 默认 10 / 20 / 30",
      ArbStatCopulaEntryKlineFilterOscLength: "指标周期",
      ArbStatCopulaEntryKlineFilterNatrExpandLength: "ATR 周期",
      ArbStatCopulaEntryKlineFilterNatrExpandHint:
        "range_high 是 TR/ATR 倍数，不是 NATR%。常态约 1，2.0 表示不超过约 2 倍近期 ATR。推荐起步：周期 14、区间 0～2.0、区间内。偏严用 1.5，只拦极端用 2.5～3.0。",
      ArbStatCopulaEntryKlineFilterNatrExpandRangeUnit:
        "倍数，非常态波动百分比",
      ArbStatCopulaEntryKlineFilterNatrExpandPredicatesHint:
        "恰好一个：区间内（默认，膨胀未超上限才开仓）或区间外",
      ArbStatCopulaEntryKlineFilterPredicates: "判定种类",
      ArbStatCopulaEntryKlineFilterPredicatesHint:
        "MA 类仅可选趋势/震荡判定；CCI/RSI 仅可选区间内/区间外；Stoch RSI 的反转必留，其余判定可添加；每条规则至少 1 项",
      ArbStatCopulaEntryKlineFilterPredicateAdd: "添加判定",
      ArbStatCopulaEntryKlineFilterPredicateRemove: "删除",
      ArbStatCopulaEntryKlineFilterPredicate_trend_with_open:
        "趋势与开仓方向一致",
      ArbStatCopulaEntryKlineFilterPredicate_trend_against_open:
        "趋势与开仓方向相反",
      ArbStatCopulaEntryKlineFilterPredicate_trend_block_open: "趋势时禁止开仓",
      ArbStatCopulaEntryKlineFilterPredicate_range_allow_both: "震荡双向放行",
      ArbStatCopulaEntryKlineFilterPredicate_range_block_both: "震荡不放行",
      ArbStatCopulaEntryKlineFilterPredicate_outside_range: "区间外",
      ArbStatCopulaEntryKlineFilterPredicate_inside_range: "区间内",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_reversal:
        "Stoch RSI 反转（必选）",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_entry_cross:
        "开仓 K/D 交叉",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_exit_cross:
        "平仓 K/D 交叉",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_exit_independent:
        "条件成立即平仓",
      ArbStatCopulaEntryKlineFilterPredicate_stoch_rsi_exit_with_signal:
        "跟随信号回归平仓",
      ArbStatCopulaEntryKlineFilterStochPredicatesHint:
        "反转必留且不可删除。开仓交叉只改开仓方向。平仓交叉只给平仓追加 K/D。独立平仓与跟随信号互斥；都不选则 Stoch 不平仓。持仓时间到点仍平仓。",
      ArbStatCopulaEntryKlineFilterStochPredicateInvalid:
        "Stoch RSI 判定无效：必须包含反转，不能重复，且独立平仓与跟随信号不能同时选择",
      ArbStatCopulaEntryKlineFilterRange: "数值区间",
      ArbStatCopulaEntryKlineFilterRangeLow: "下限",
      ArbStatCopulaEntryKlineFilterRangeHigh: "上限",
      ArbStatCopulaEntryKlineFilterFactorTypeInvalid: "请选择有效的因子类型",
      ArbStatCopulaEntryKlineFilterPeriodInvalid:
        "周期须为上方 K 线周期配置的子集",
      ArbStatCopulaEntryKlineFilterLengthsInvalid:
        "长度须为严格递增的整数（每项 ≥ 2，不可重复）",
      ArbStatCopulaEntryKlineFilterPredicatesInvalid: "请至少选择一种判定种类",
      ArbStatCopulaEntryKlineFilterRangeInvalid: "区间须满足 下限 < 上限",
      ArbStatNoTradeSchedule: "不可交易时段",
      ArbStatNoTradeScheduleEnabled: "启用不可交易时段",
      ArbStatNoTradeScheduleHint:
        "仅禁止新开仓，不影响平仓；半开区间 [start,end)；跨夜/跨周合法；全天禁开需多窗口拼接。关闭开关表示不限制。",
      ArbStatNoTradeTimezone: "时区",
      ArbStatNoTradeWindowItemTitle: "窗口 {index}",
      ArbStatNoTradeWindowAdd: "添加窗口",
      ArbStatNoTradeWindowRemove: "删除",
      ArbStatNoTradeWindowType: "类型",
      ArbStatNoTradeWindowType_daily: "每日",
      ArbStatNoTradeWindowType_weekly: "每周",
      ArbStatNoTradeStart: "开始时间",
      ArbStatNoTradeEnd: "结束时间",
      ArbStatNoTradeStartDow: "开始星期",
      ArbStatNoTradeEndDow: "结束星期",
      ArbStatNoTradeDow_1: "周一",
      ArbStatNoTradeDow_2: "周二",
      ArbStatNoTradeDow_3: "周三",
      ArbStatNoTradeDow_4: "周四",
      ArbStatNoTradeDow_5: "周五",
      ArbStatNoTradeDow_6: "周六",
      ArbStatNoTradeDow_7: "周日",
      ArbStatNoTradeNeedOneWindow: "请至少添加一个不可交易窗口",
      ArbStatNoTradeTypeInvalid: "窗口类型须为每日或每周",
      ArbStatNoTradeClockInvalid: "时间格式须为 HH:mm",
      ArbStatNoTradeDowInvalid: "星期须为 1（周一）至 7（周日）",
      ArbStatNoTradeStartEndMustDiffer: "开始与结束不可完全相同",
      ArbStatCointRatioRsiExitEnabled: "启用 RSI 回归",
      ArbStatCointRatioRsiLength: "周期（默认 14）",
      ArbStatCointRatioRsiUpper: "上边界（默认 70）",
      ArbStatCointRatioRsiLower: "下边界（默认 30）",
      ArbStatCointRatioRsiMinProfitFrac: "浮盈比例（默认 0.2）",
      ArbStatCointRatioRsiUseSymmetricArms: "方向解耦（默认否）",
      ArbStatCointRatioRsiParamsInvalid:
        "RSI 回归：周期须为不小于 2 的整数；须满足 0 ≤ 下边界 < 上边界 ≤ 100；浮盈比例须在 (0, 1] 内。",
      ArbStatMinGainCoint: "仓位止盈比例",
      ArbStatMaxDrawdownCoint: "仓位止损比例",
      ArbStatCointStopLossCooldownEnabled: "启用连续止损冷静",
      ArbStatCointStopLossLimit: "连续协整止损次数",
      ArbStatCointStopLossCooldownMinutes: "止损冷静时长",
      ArbStatCointStopLossCooldownHint:
        "同一配对连续协整止损达到次数后，暂停对该对开仓。与平仓后的普通冷却（约 100 秒）不是同一项。关闭须提交 -1，不要填 0。",
      ArbStatCointStopLossCooldownParamsInvalid:
        "连续止损次数须为不小于 1 的整数；冷静时长须至少 1 分钟。",
      ArbStatCointVolScaleEnabled: "协整波动缩放",
      ArbStatCointVolScaleHint:
        "须先勾选「动态止盈止损」。开启后 MinGain、MaxDrawdown 及 tier/trail 美元门槛按价格比波动比例缩放；具体生效条件由服务端缓冲数据决定。",
      ArbStatCointVolScaleWindow: "短窗一阶差分个数",
      ArbStatCointVolScaleMinMult: "缩放比例下限",
      ArbStatCointVolScaleMaxMult: "缩放比例上限",
      ArbStatCointVolScaleWindowInvalid: "短窗差分个数须为不小于 2 的整数。",
      ArbStatCointVolScaleMultInvalid:
        "缩放下限、上限须为正数，且下限须小于上限。",
      ArbStatCointDynamicPnlTierTrail: "动态止盈止损",
      ArbStatCointTrailArmFrac: "跟踪启用系数",
      ArbStatCointTrailPullbackMult: "跟踪回吐倍数",
      ArbStatCointTier1GainFrac: "台阶一达线系数",
      ArbStatCointTier1StopMult: "台阶一止损倍数",
      ArbStatMaxHoldMinutes: "最大持仓时间",
      ArbStatMaxHoldExitMode: "最长持仓平仓方式",
      ArbStatMaxHoldExitModeFixedTime: "固定持仓时间",
      ArbStatMaxHoldExitModeStoch: "Stoch RSI 反转",
      ArbStatMaxHoldExitModeStochHint:
        "已改为判定条件。旧反转配置会迁成独立平仓，持仓时间到点仍平仓。",
      ArbStatMaxHoldExitModeInvalid:
        "平仓方式无效，只能是固定持仓时间或 Stoch RSI 反转",
      ArbStatMaxHoldExitModeNeedsStoch:
        "选择 Stoch RSI 反转平仓时，必须且只能有一条 Stoch RSI 过滤项",
      ArbStatMaxHoldExitModeStochConflict:
        "旧的 Stoch RSI 反转平仓与跟随信号不能同时配置",
      ArbStatEnableHoldPnLCurve: "启用持仓浮盈曲线",
      ArbStatHoldPnLEnvelopeSegments: "包络分段数",
      ArbStatHoldPnLParamsInvalid: "持仓浮盈曲线：分段数须为 8～128 的整数。",
      MinutesUnit: "分钟",
      IsMoveGrid: "移动网格",
      FollowBook: "跟随盘口",
      IsCollabExec: "协同执行",
      IsTrendExec: "趋势执行",
      IsSyncOrder: "同步挂单",
      InvestmentAmount: "投资额",
      IsOpenArb: "启用套利",
      AuthorizedObserver: "授权观察者",
      PositionAvailable: "可用仓位",
      PositionInit: "初始仓位",
      KlineCycle: "K线周期",
      OpenPositionQuantile: "开仓分位数",
      ClosePositionQuantile: "平仓分位数",
      Leverage: "杠杆",
      IsLong: "做多",
      IsShort: "做空",
      IsBoth: "中性",
      IsUseCurrentPosition: "继承仓位",
      IsNotReQuote: "只报价一次",
      IsOpen: "开仓",
      Side: "方向",
      OnlyLong: "允许做多",
      OnlyShort: "允许做空",
      LongAndShort: "多空双开",
      StrongDecision: "强势判定",
      BuyOrderSpacingRatio: "买单间距比例",
      SellOrderSpacingRatio: "卖单间距比例",
      EquivalentRatio: "等比",
      EquivalentDifferences: "等差",
      TakeProfitStopLoss: "止盈止损",
      TakeProfit: "止盈",
      StopLoss: "止损",
      PriceRange: "价格区间",
      HighPoint: "高点",
      LowPoint: "低点",
      BuyOrder: "买单",
      SellOrder: "卖单",
      PendingOrderLogarithm: "挂单对数",
      SymbolSettings: "交易对设置",
      RateGridLongSymbol: "做多交易对",
      RateGridTradeSymbol: "做空交易对",
      AddCurrentSymbol: "添加交易对",
      AddCurrentCurrency: "添加币种",
      GoBack: "返回",
      Confirm: "确认",

      MaxOrderQty: "单笔最大下单量",
      ExecConfig: "执行器配置",
      ExecMinOrderQty: "单笔最小下单量",
      ExecMaxSplitOrder: "最大拆单数",
      ExecBaseSplitOrder: "基准拆单数",
      ExecOrderTimeout: "单笔订单超时时间",
      ExecTimeout: "完整超时时间",
      ExecTimeoutTaker: "超时后是否吃单",

      NO_MARGIN: "不启用杠杆",
      NO_SIDE_EFFECT: "启用杠杆不自动借还",
      MARGIN_BUY: "杠杆自动借币",
      AUTO_REPAY: "杠杆自动还币",
      AUTO_BORROW_REPAY: "杠杆自动借还",

      ArbFundingConfig: "资金费率套利配置",
      Tips: "提示",
      CurrencyWhiteList: "币种白名单",
      MaxTradeQty: "最大可用金额",
      TriggerFundingRateThreshold: "触发资金费率阈值",
      TriggerFundingRateMinute: "触发资金费率启动时间",
      TriggerSpotSide: "触发现货方向",
      TriggerSpotAll: "双向现货买卖",
      TriggerSpotBuy: "只做现货买入",
      TriggerSpotSell: "只做现货卖出",
      MinSplitUsd: "最小拆单额",
      MaxSplitUsd: "最大拆单额",
      BaseSplitCount: "基准拆单数量",
      PleaseSetCurrencyWhiteList: "请先设置币种白名单",
      TriggerTime: "套利触发时间",
      CurrentFundingRate: "当前资金费率",
      CurrentFundingRateTime: "当前资金费率时间",
    },
    Command: {
      Running: "运行中",
      History: "历史",
      ObserverRunning: "观察者运行中",
      ObserverHistory: "观察者历史",
      RiskRunning: "风控运行中",
      RiskHistory: "风控历史",

      Instance: {
        ShowZeroPosition: "显示历史持仓",

        //期权
        Equity: "账户资产净值",
        TotalEquityUsd: "账户资产净值(美元)",
        Im: "初始保证金率",
        Mm: "维护保证金率",
        TotalFloating_Profit_Loss_Usd: "损益(美元)",
        TotalProfit_Loss: "损益",
        Roi: "ROI",
        Total_Delta: "Delta",
        Total_Gamma: "Gamma",
        Total_Vega: "Vega",
        Total_Theta: "Theta",
        Total_Rho: "Rho",

        SubAccount: "子账户",
        All: "全部",
        SelectionPeriod: "选择时间段",

        StopInstance: "停止实例",
        Tags: "标签",
        EditTags: "编辑",
        FilterByTags: "按标签筛选",
        TagEditTitle: "编辑标签",
        TagCurrent: "当前标签",
        TagAdd: "添加标签",
        TagEmptyHint: "暂无标签",
        TagInputHint: "输入后按回车添加",
        TagHistoryLabel: "历史标签（点击添加）",
        TagPlaceholder: "输入标签",
        TagConfirm: "确定",
        TagCancel: "取消",
        TagSaveFailed: "标签保存失败，请重试",
        ChangeParameters: "修改参数",
        ReuseParameters: "复用参数",
        Archive: "归档",
        PositionOverview: "仓位概览",
        ReplayProgressTitle: "回测进度",
        ReplayProgressPct: "当前进度",
        ReplayElapsedSim: "回测已推进时间",
        ReplayEffectiveRate: "总体回放速率",
        ReplaySimClock: "当前模拟时钟",
        ReplayTimeRange: "回测时间段",
        ReplayDataUpdatedAt: "数据最后更新时间",

        //价差套利
        ArbSpreadOverview: "价差套利概览",

        //运行状况
        ArbSpreadRunStatus: "运行状况",
        ArbSpreadTotalCount: "套利完成次数",
        ArbSpreadTotalEstimatedReturn: "总预估收益率",
        ArbSpreadTotalRealReturn: "总实际收益率",
        ArbSpreadTotalSlippage: "总滑点",

        //订单下单耗时
        ArbSpreadOrderDurationData: "订单下单耗时",
        ArbSpreadOrderDurationAvg: "平均下单耗时",
        ArbSpreadOrderDurationMax: "最优下单耗时",
        ArbSpreadOrderDurationMin: "最劣下单耗时",

        //收益率
        ArbSpreadReturnData: "收益率",
        ArbSpreadReturnAvg: "平均收益率",
        ArbSpreadReturnMax: "最优收益率",
        ArbSpreadReturnMin: "最劣收益率",

        //滑点
        ArbSpreadSlippageData: "滑点数据",
        ArbSpreadSlippageAvg: "平均滑点",
        ArbSpreadSlippageMax: "最优滑点",
        ArbSpreadSlippageMin: "最劣滑点",

        //套利详情
        ArbSpreadDetail: "套利详情",
        ArbSpreadDetailId: "序号",
        ArbSpreadDetailTime: "时间",
        ArbSpreadDetailAction: "动作",
        ArbSpreadDetailBuySymbol: "买入交易对",
        ArbSpreadDetailSellSymbol: "卖出交易对",
        ArbSpreadDetailBuyPrice: "买入成交价",
        ArbSpreadDetailSellPrice: "卖出成交价",
        ArbSpreadDetailEstimateReturn: "预估收益率",
        ArbSpreadDetailRealReturn: "实际收益率",
        ArbSpreadDetailSlippage: "滑点",
        ArbSpreadDetailSyncDuration: "双边同步耗时",
        ArbSpreadDetailBuyOrderDuration: "买入订单耗时",
        ArbSpreadDetailSellOrderDuration: "卖出订单耗时",

        CollabExecOverview: "协同执行概览",
        CollabExecRunData: "执行数据",
        CollabExecToTalCount: "成交对数",
        CollabExecAvgWaitDurationMs: "平均等待时长",
        CollabExecUpdateTime: "最后更新时间",
        CollabExecRunTime: "运行时长",

        CollabExecSlippageData: "滑点数据",
        CollabExecAvgSlippageBps: "平均滑点(基点)",
        CollabExecMaxSlippageBps: "最优滑点(基点)",
        CollabExecMinSlippageBps: "最劣滑点(基点)",

        CollabExecSlippageLoss: "滑点影响",
        CollabExecTotalSlippageLoss: "累计滑点影响(USD)",
        CollabExecAvgSlippageLoss: "平均滑点影响(USD)",
        CollabExecMaxSlippageLoss: "最优单次滑点影响(USD)",
        CollabExecMinSlippageLoss: "最劣单次滑点影响(USD)",

        ArbFundingOverview: "资金费率套利概览",
        TotalTradeQty: "总成交额",
        TotalFundingProfit: "累计资金费收益",
        TotalCloseProfit: "累计平仓收益",
        TotalOrderFee: "累计手续费",
        TotalEstimatedBorrowInterest: "累计预估借币利息",
        TotalNetProfit: "累计净盈亏",

        TradeQty: "成交额",
        PreFundingRate: "预估资金费率",
        RealFundingRate: "实际资金费率",
        RealFundingProfit: "实际资金费收益",
        CloseProfit: "平仓收益",
        EstimatedBorrowInterest: "预估借币利息",
        SettleTimes: "结算次数",

        TradeRecord: "交易记录",
        InitiallyAvailable: "资金规模",
        TotalTransaction: "总成交额",
        StrategicBenefits: "已实现盈亏",
        TotalHoldingProfit: "未实现盈亏",
        TotalProfit: "总盈亏",
        CurrentPosition: "当前仓位",
        PositionDirection: "仓位方向",
        BuyAvgPrice: "买入均价",
        SellAvgPrice: "卖出均价",
        TransactionQty: "成交额",
        Progress: "进度",
        EsmaticRemainTime: "预估剩余时间",
        AverageHoldingPrice: "持仓均价",
        MarkPrice: "标记价格",
        Notional: "名义价值",
        MaxPositionNotional: "最大持仓名义价值",
        HoldingProfit: "未实现盈亏",
        PolicyDetails: "策略详情",
        IncomeLevel: "收益水位",
        HighIncomeLevel: "高水位",
        LowIncomeLevel: "低水位",
        MaximumDrawdown: "最大回撤",
        SingleProfit: "单盈利",
        MaximumProfit: "最大盈利",
        MinimumProfit: "最小盈利",
        MaximumLoss: "最大亏损",
        MinimumLoss: "最小亏损",
        ProfitAndLossTimes: "盈亏次数",
        ProfitTimes: "盈利次数",
        LossTimes: "亏损次数",
        ProfitAndLoss: "盈亏",
        TotalProfit2: "累计盈利",
        TotalLoss: "累计亏损",
        TotalRebate: "累计手续费",
        NetProfit: "净盈利",
        NetPosition: "净持仓",
        ProfitAndLossRatio: "盈亏比",
        TransactionVolume: "成交量",
        Buy: "买",
        Sell: "卖",
        Total: "总",
        TransactionRole: "交易角色",
        TakerCount: "Taker次数",
        MakerCount: "Maker次数",
        TakerQty: "Taker成交额",
        MakerQty: "Maker成交额",
        WinRate: "胜率",
        Detail: "查看详情",
        SubAccountBalance: "子账户余额",
        StrategyStatus: "策略状态",
        AccountType: "交易类型",
        StartupTime: "启动时间",
        ArbStatParamSummary: "参数设定",
        StopConfirm: "确认停止该实例?",
        StopConfirmTips: "此操作无法撤销!",
        Confirm: "确认",
        Cancel: "取消",
        ActionSuccess: "操作成功",
        ActionFailed: "操作失败",

        CurrentPositionDirection: "当前仓位方向",
        Time: "时间",
        CumBuyU: "累计买入U量",
        CumBuyC: "累计买入币量",
        AvgBuyPrice: "买入均价",
        CumSellU: "累计卖出U量",
        CumSellC: "累计卖出币量",
        AvgSellPrice: "卖出均价",
        InitPosition: "初始持仓数量",
        CurrPosition: "当前持仓数量",
        CurrVolumn: "当前交易量",
        CurrValue: "当前币种敞口价值上限",

        GroupId: "组ID",
        BuyAmount: "买入数量",
        SellAmount: "卖出数量",
        BuyQty: "买入金额",
        SellQty: "卖出金额",
        Profit: "盈亏",
        OrderFee: "手续费",
        StartTime: "开始时间",
        RunTime: "运行时长",
        Action: "操作",

        Day: "天",
        Hour: "小时",
        Minute: "分钟",
        Second: "秒",

        ProfitModal: {
          YieldCurve: "收益曲线",
          IgnoreTransactionFees: "忽略手续费",
          BacktestSymbolFilter: "配对组合过滤",
          BacktestPeriodFilter: "触发周期过滤",
          BacktestSlippageCorrection: "冲击系数",
          BacktestSlippagePermyriadUnit: "万分点",
          BacktestFeeRateCorrection: "手续费率",
          CumulativeIncome: "累计收益",
          AverageValue: "平均值",
          SingleIncome: "单笔收益",
          IsLong: "做多",
          IsShort: "做空",
        },
        GroupModal: {
          IntraGroupTransactionRecord: "组内交易记录",
          ShowOnlyTradedOrders: "仅显示已成交订单",
          OrderTime: "挂单时间",
          TransactionTime: "成交时间",
          TransactionDirection: "交易方向",
          TargetPrice: "目标价格",
          TargetAmount: "目标数量",
          AvgPrice: "成交均价",
          Vol: "成交数量",
          Qty: "成交额",
          Role: "成交角色",
          Status: "状态",
          OrderFee: "手续费",
          Total: "总计",
          Record: "条记录",
          TotalAvgPrice: "总成交均价",
          TotalVol: "总成交数量",
          TotalAmount: "总成交额",
        },
        ArbStat: {
          ArbitrageRecord: "套利记录",
          ViewDetail: "查看详情",
          NoOrderData: "无订单数据",
          IncomeStats: "收益统计",
          SignalIndicator: "信号指标",
          JointStrength: "联合强度",
          Confidence: "置信度",
          StrengthThreshold: "强度阈值",
          AvgCorrelation: "平均相关性",
          CloseReason: "平仓原因",
          LongShortDeviationScore: "多空偏离度得分",
          DeviationScore: "偏离度得分",
          LongScore: "多头得分",
          ShortScore: "空头得分",
          Overvalued: "高估",
          Undervalued: "低估",
          StopLoss: "止损",
          TakeProfit: "止盈",
          PositionTimeout: "持仓超时",
          SignalRegression: "信号回归",
          PairReversal: "配对反转",
          RhoDrop: "相关性降",
          PositionTakeProfit: "仓位止盈",
          CointTrailingStop: "跟踪止损",
          PositionStopLoss: "仓位止损",
          EmergencyStop: "紧急止损",
          InstanceStop: "实例停止",
          PositionSizeLimit: "仓位超限",
          CloseReasonLegacyResume: "续跑落库(历史)",
          Max: "Max",
          Min: "Min",
          OpenTime: "开仓时间",
          BuySymbol: "买入标的",
          SellSymbol: "卖出标的",
          OpenSize: "开仓规模",
          SignalPeriod: "信号周期",
          OpenBuyPrice: "开仓买价",
          OpenSellPrice: "开仓卖价",
          CloseTime: "平仓时间",
          CloseSellPrice: "平仓卖价",
          CloseBuyPrice: "平仓买价",
          TotalProfit: "总收益",
          TotalFee: "总手续费",
          NetProfit: "净收益",
          ReturnRatio: "收益率",
          NetProfitRatio: "净收益率",
          ExecutionSlippageRate: "执行滑点率",
          TakerSlippageRate: "吃单滑点率",
          SlippageVsL1Maker: "L1 挂单滑点",
          SlippageVsTakerPrice: "Taker价差",
          TotalCostVsTaker: "成本节省",
          TotalCostSkipDepthInsufficient: "盘口深度不足",
          TotalCostSkipFeeRateMissing: "费率未采集",
          TotalCostSkipBenchmarkIncomplete: "基准未齐全",
          TotalCostTooltipPrice: "价差",
          TotalCostTooltipFee: "费率",
          TotalCostTooltipSkip: "未计算",
          TakerBenchFillPct: "可扫占比",
          TakerSlippageCovered: "可衡量口径",
          TotalCostCovered: "可衡量口径",
          HoldAnalysis: "持仓分析",
          HoldOverviewTitle: "持仓盈亏结构总览",
          HoldOverviewScatterSeries: "触发浮盈",
          HoldOverviewCandleSeries: "累计权益（K 线）",
          HoldOverviewCumYAxis: "累计净收益 (USD)",
          HoldOverviewCumNet: "累计净收益",
          HoldOverviewTradeNet: "本笔净收益",
          HoldOverviewCumHigh: "累计权益峰值",
          HoldOverviewCumLow: "累计权益谷值",
          HoldOverviewExecVolume: "执行损耗",
          HoldOverviewCumExecCostLine: "累计执行成本",
          HoldOverviewAvgExecCostLine: "平均执行成本",
          HoldOverviewTipOpen: "开",
          HoldOverviewTipHigh: "高",
          HoldOverviewTipLow: "低",
          HoldOverviewTipClose: "收",
          HoldOverviewTipCost: "成本",
          HoldOverviewTipGiveBack: "回吐",
          HoldOverviewMfeApprox: "最大浮盈（触发价估算）",
          HoldOverviewGiveBackHint: "峰值至净收益回吐",
          HoldOverviewYAxis: "浮盈 (USD)",
          HoldOverviewPermYAxis: "万分点 (‱)",
          HoldOverviewMaePermLine: "最大浮亏比率",
          HoldOverviewMfePermLine: "最大浮盈比率",
          HoldOverviewMfeBar: "最大浮盈",
          HoldOverviewNetBar: "净收益",
          HoldOverviewMaeBar: "最大浮亏",
          HoldOverviewExecCostBar: "执行损耗",
          HoldOverviewGiveBack: "峰值回吐",
          HoldOverviewNoData: "暂无已平仓记录",
          HoldTriggerPnl: "触发浮盈",
          HoldGrossFallback: "已实现毛收益（无持仓曲线）",
          HoldGiveBackFromPeak: "峰值回吐",
          HoldDuration: "持仓时间",
          HoldNoCurveBadge: "无持仓曲线数据",
          HoldIncompleteBadge: "回测截断持仓",
          HoldPnLNoData: "该笔无持仓曲线数据",
          HoldSelectHint: "请在上方图表中点击选择一笔交易",
          HoldSelectedTrade: "已选交易",
          HoldEnvelopeTitle: "持仓浮盈包络",
          HoldEnvelopeBand: "段内包络带",
          HoldEnvelopeCandle: "段内K线",
          HoldEnvelopePath: "段内路径",
          HoldEnvelopeMax: "段内最大",
          HoldEnvelopeMin: "段内最小",
          HoldEnvelopeFirst: "段内首笔",
          HoldEnvelopeLast: "段内末笔",
          HoldEnvelopeSparseHint: "分段稀疏，空段无采样",
          HoldEnvelopeNoSample: "该进度段无采样",
          HoldProgressAxis: "持仓进度",
          HoldUnrealizedPnl: "未实现浮盈 (USD)",
          HoldProfitTarget: "止盈线",
          HoldEffectiveStop: "有效止损",
          HoldMFE: "MFE",
          HoldMAE: "MAE",
          HoldTFP: "TFP",
          HoldPctTimeInProfit: "盈利时间占比",
          HoldAttributionTitle: "盈亏归因",
          HoldAttributionComposition: "盈亏构成",
          HoldAttributionRealizedPnL: "实现盈亏",
          HoldExecutionLeak: "执行损耗",
          HoldFeeImpact: "手续费",
          ExecutionEvaluation: "执行评判",
          ExecutionCostComparison: "单笔执行成本",
          ExecutionSavingComparison: "单笔执行节省",
          ExecutionCostUsd: "执行成本",
          ExecutionSaving: "执行节省",
          PriceSaving: "价差节省",
          FeeSaving: "费差节省",
          CumulativeSaving: "累计节省",
          CostToGrossRatio: "成本占毛利",
          CostRatioBasisNetAbs: "亏损笔，分母为净利绝对值",
          CostRatioBasisLossZone: "毛利非正，阈外占位",
          ExecutionTiming: "腿同步与执行窗口",
          ExecutionTimingAndThroughput: "腿同步、窗口与吞吐",
          TradeThroughput: "执行吞吐",
          LegDurationSkew: "四腿耗时差异",
          TotalExecWindow: "总执行窗口",
          ExecutionDiagnostic: "执行诊断",
          ExecutionDiagnosticHint:
            "绿=盈利 红=亏损 · 气泡=成交额 · X=成本/成交额(‱，负=较L1优) · 虚线为及格线",
          DiagnosticAxisCost: "执行成本/成交额 (‱，负=较L1优)",
          DiagnosticAxisSkew: "同侧腿耗时差异 (s)",
          DiagnosticCostTurnover: "执行成本/成交额",
          DiagnosticExecutionCost: "执行成本 (USD，负=节省)",
          DiagnosticCostGrossSkip: "—（微利不可比）",
          DiagnosticCumQuote: "四腿成交额",
          DiagnosticCostThreshold: "万4 成本线",
          DiagnosticSkewThreshold: "30s 同步线",
          QuadrantIdeal: "① 理想",
          QuadrantWarnSync: "② 同步差",
          QuadrantWarnCost: "③ 成本高",
          QuadrantWorst: "④ 警惕",
          TradeNetProfit: "单笔净利",
          NoTimingData: "暂无四腿耗时数据",
          LegExecutionVelocity: "四腿执行吞吐",
          LegOpenBuy: "开买",
          LegOpenSell: "开卖",
          LegCloseBuy: "平买",
          LegCloseSell: "平卖",
          LegDuration: "耗时",
          LegVelocityUnit: "USD/s",
          NoExecutionData: "暂无执行成本数据",
          NoLegDurationData: "暂无四腿耗时数据",
          Action: "操作",
          ChartModeGlobal: "全局",
          ChartModeLegs: "三标的",
          ChartModeBtcEth: "BTC-ETH",
          ChartModeBtcSol: "BTC-SOL",
          ChartModeEthSol: "ETH-SOL",
          ChartModeXagXau: "XAG-XAU",
          ChartModeCopperXau: "COPPER-XAU",
          PoolSectionLabel: "池",
          PoolCrypto: "BTC-ETH-SOL",
          PoolMetal: "XAU-XAG-COPPER",
          AssetClassSectionLabel: "资产类",
          AssetClassCrypto: "加密货币",
          AssetClassFuturesmkt: "传统期货",
          PoolSoyChain: "S-ZL-ZM",
          PoolGrains: "C-S-W",
          PoolUsIndex: "ES-NQ-YM",
          PoolPreciousMetals: "MGC-SI-HG",
          PoolCommodityFx: "AD-CD-NE",
          ModeSectionLabel: "模式",
          MarketSectionLabel: "市场",
          MarketSpot: "现货",
          MarketFutures: "合约",
          ExchangeSectionLabel: "交易所",
          ExchangeBinance: "Binance",
          ExchangeOkx: "OKX",
          UniverseLockedWhileEditing:
            "正在修改实例参数，无法切换资产类或池（加密货币下亦含交易所、市场）。请先取消更新。",
          FilterState: "状态",
          FilterSector: "板块",
          SectorAll: "全部",
          StateAll: "全部",
          StateActive: "活跃",
          StatePending: "待定",
          StateRetired: "退役",
          StatePaused: "暂停",
          LoadingPools: "加载配对池中…",
          LoadingFailed: "加载失败，请稍后重试",
          NoPools: "暂无可用配对池",
          SearchPlaceholder: "搜索配对…",
          NoSearchResults: "无匹配配对",
        },
        Charts: {
          TimelineCycle: "交易与收益率",
          EfficiencyBubble: "滑点与耗时",
          TransactionReturn: "交易收益率",
          OpenClosePoints: "开平仓点位",
        },
      },
    },
  },

  AINEws: {
    Title: "AI实时资讯",
    ImportantOnly: "只看重要",
    ScrollToLoadMore: "向下滚动加载更多",
    NoMoreMessages: "没有更多了",
    Today: "今天",
    Important: "重要",
    Normal: "普通",
  },
  ModalInfo: {
    ConfirmCancelExchange: "是否确认撤销该挂单?",
    ConfirmCancelBail: "是否确认撤销委托?",
    ConfirmCancelAllExchange: "是否确认撤销全部挂单?",
    ConfirmMarketClosePosition: "是否确认市价平仓?",
    ConfirmOrder: "是否确认下单?",

    ConfirmTips: "此操作无法撤销!",
    Yes: "是",
    No: "否",
    CancelAction: "取消操作",
    ActionSuccess: "操作成功",
    ActionFailed: "操作失败",
  },

  ExchangeName: {
    All: "全部",
    Binance: "币安",
    Okex: "OKX",
    Huobi: "火币",
    Coinbase: "COINBASE",
    Deribit: "DERIBIT",
    AISelect: "AI选币",
    Bybit: "BYBIT",
    Gate: "GATE",
    TradingX: "TradingX",
    Aster: "Aster",
    Sunx: "SUNX",
    XCoin: "XCoin",
    Bitget: "Bitget",
    Futuresmkt: "传统期货",
    CBOT: "CBOT",
    CME: "CME",
    COMEX: "COMEX",
    EUREX: "EUREX",
    HKEX: "HKEX",
    NYMEX: "NYMEX",
    SGX: "SGX",
  },
  AccountType: {
    Spot: "现货",
    Future: "U本位合约",
    Swap: "币本位合约",
    Option: "期权",
    Index: "指数",
  },

  OkxAccountType: {
    SPOT: "现货",
    SWAP: "永续",
    SWAPALL: "永续合约",
    FUTURES: "交割",
    FUTURESALL: "交割合约",
  },

  BybitAccountType: {
    SPOT: "现货",
    LINEAR: "U本位合约",
    INVERSE: "反向合约",
    spot: "现货",
    linear: "U本位合约",
    inverse: "反向合约",
    OPTION: "期权",
    Perpetual: "永续",
    Inverse: "反向",
  },

  GateAccountType: {
    SPOT: "现货",
    FUTURES: "永续",
    FUTURESALL: "永续合约",
    DELIVERY: "交割",
    DELIVERYALL: "交割合约",
  },
  SunxAccountType: {
    SWAP: "永续",
  },
  XcoinAccountType: {
    SPOT: "现货",
    LINEAR_PERPETUAL: "永续",
    LINEAR_FUTURES: "交割",
  },
  Kchart: {
    SaveStudy: "保存指标",
    LoadStudy: "加载指标",
  },

  KChartBox: {
    SelectInterval: "选择周期",
    Edit: "编辑",
    Save: "保存",
  },

  FuturesSymbol: {
    GC0W_CMX: "金主连",
    SI0W_CMX: "银主连",
    HG0W_CMX: "铜主连",
    PL0W_NMX: "铂主连",
    CL0W_NMX: "WTI原油主连",
    NG0W_NMX: "天然气主连",
    RB0W_NMX: "RBOB汽油主连",
  },

  AstockSymbol: ASTOCK_LIST,

  ArbSelect: {
    Portfolio: "投资组合",
    ThreeDayCumulativeFundingRateShort: "3日累计资金费率",
    ThreeDayCumulativeFundingRate: "3日累计资金费率",
    ThreeDayCumulativeYield: "3日累计收益率",
    SevenDayCumulativeFundingRate: "7日累计资金费率",
    SevenDayCumulativeYield: "7日累计收益率",
    ThirtyDayCumulativeFundingRate: "30日累计资金费率",
    ThirtyDayCumulativeYield: "30日累计收益率",
    APR: "年利率",
    FundingRate: "资金费率",
    FundingRateHistory: "资金费率历史",
    RealTimeFundingRate: "实时资金费率",
    FundingInterval: "资金费率间隔",
    Time: "时间",
    TimeInterval: "时间间隔",
    TimeToNextFunding: "到下次资金费时间",
    NextFunding: "下次资金费率",
    Hour: "小时",
    Day: "天",
    Days: "天",
    BaseInterestRate: "基础利率",
    FundingRateUpperLimitLowerLimit: "资金费率上限/下限",
    MarkPrice: "标记价格",
    CountDown: "倒计时",
    DeliveryCountDown: "交割倒计时",
    History: "历史",
    Contract: "合约",
    SpreadTrend: "价差趋势",
    Chart: "图表",
  },
  SpreadArb: {
    All: "全部",
    Spot: "现货",
    Contract: "合约",
    Delivery: "交割",
    Other: "山寨币",
    APR: "预估年化",
    Leg1: "腿 1",
    Leg2: "腿 2",
    BuySymbol: "买入交易对",
    SellSymbol: "卖出交易对",
    Spread: "价差",
    SpreadRate: "价差率",
    Change: "24h涨跌幅",
    Expiration: "到期时间",
    Liquidity: "最大流动性",
    Cliquidity: "流动性(币)",
    Uliquidity: "流动性(USDT)",
  },

  NetValue: {
    Title: "收益回撤曲线",
    NetValueCurve: "净值曲线",
    Value: "净值",
    NetValue: "净值",
    Drawdown: "回撤",
    ReturnDrawdown: "收益回撤曲线",
    MaxDrawdown: "最大回撤",
    CumulativeReturn: "累计收益率",
    Percentage: "百分比(%)",
    MaxReturn: "最大累计收益率",
    ProfitLoss: "盈亏曲线",
    Profit: "当期盈亏",
    DailyReturn: "当期收益率",
    CumulativeProfit: "累计盈亏",
    Amount: "金额",
    Date: "日期",
    Balance: "余额",
    ReturnRate: "收益率",
    HighWaterMark: "高水位",
    LowWaterMark: "低水位",
    CurrentDrawdown: "当前回撤",
    MaxDrawdownCol: "最大回撤",
    AnnualizedReturn: "年化收益率",
    AnnualizedVolatility: "年化波动率",
    Sharpe: "夏普",
    SharpeRatio: "夏普比率",
    DataTable: "数据表格",
    ExportExcel: "导出Excel",
    Transfer: "划转",
  },

  TXUI: {
    Orderbook: {
      Merge: "合并",
      Split: "分离",
    },
  },
  SOROrder: {
    SmartOrderRouting: "智能路由订单",
    SubAccountSelector: "子账户选择",
    AccountsSelected: "个子账户已选择",
    SelectAll: "全选",
    AvailableToBuy: "可买入",
    AvailableToSell: "可卖出",
    Buy: "买入",
    Sell: "卖出",
    CanBuy: "可买入",
    CanSell: "可卖出",
    EnableLiquidity: "启用流动性",
    EnableSOR: "启用SOR",
    EnableCollab: "启用协同",
    Limit: "限价",
    Market: "市价",
    Quantity: "数量",
    Direction: "方向",
    TimeInForce: "时间类型",
    TakeProfit: "止盈",
    OrderPrice: "订单价格",
    TriggerPrice: "触发价格",
    OrderSummary: "订单摘要",
    Total: "总",
    Available: "可用",
    TotalBalance: "总余额",
    AccountBalance: "账户余额",
    Symbol: "交易对",
    Exchange: "交易所",
    ExcuteSettings: "执行参数",
    QuantityRequired: "数量不能为空",
    QuantityInvalid: "输入的数量不合法",
    SelectSameExchangeSubAccount: "每个交易所仅允许选择一个子账户！",
  },
  SORCommand: {
    Trading: "交易中",
    History: "交易历史",
    Buy: "买入",
    Sell: "卖出",
    CurrentOrders: "当前订单",
    Refresh: "刷新",
    CancelAll: "全部取消",
    NoOrders: "暂无订单",
    TradeSymbol: "交易品种",
    OrderId: "订单ID",
    OrderVolume: "委托量",
    Side: "方向",
    AvgPrice: "均价",
    Progress: "进度",
    OrderStatus: "状态",
    StartTime: "开始时间",
    EndTime: "结束时间",
    TransactionTime: "成交时间",
    Action: "操作",
    Stop: "停止",
    Detail: "详情",
    OrderDetail: "订单详情",
    BasicInfo: "基本信息",
    TradeInfo: "交易信息",
    ExecutionProgress: "执行进度",
    TimeInfo: "时间信息",
    SORRouteInfo: "SOR路由信息",
    TotalValue: "总价值",
    ExecutedQty: "已执行数量",
    OrigQty: "原始数量",
    CompletionRate: "完成率",
    Duration: "持续时间",
    Hours: "小时",
    Minutes: "分钟",
    Seconds: "秒",
    Close: "关闭",
    TradeHistory: "交易历史",
    NoTradeHistory: "暂无交易记录",
    TradeId: "交易ID",
    Exchange: "交易所",
    Total: "总价值",
    Fee: "手续费",
    CopySuccess: "复制成功",
    CopyFailed: "复制失败",
    RefreshFailed: "刷新失败",
    RefreshSuccess: "刷新成功",
    OrderStopped: "订单停止成功",
    StopFailed: "停止失败",
    NoOrdersToStop: "没有可停止的订单",
    AllOrdersStopped: "所有订单已停止",
    StopAllFailed: "批量停止失败",
    StopConfirm: "确认停止该订单?",
    Yes: "是",
    No: "否",
    Status: {
      NEW: "新建",
      PARTIALLY_FILLED: "部分成交",
      FILLED: "完全成交",
      CANCELED: "已取消",
      REJECTED: "已拒绝",
      PENDING_CANCEL: "取消中",
    },
  },
  ManageSubAccountModal: {
    Title: "管理子账户",
    AddButton: "+添加子账户",
    AccountCount: "{count} 个子账户",
    AccountsCount: "{count} 个子账户",
    Empty: "暂无子账户",
    CopyApiKey: "复制APIKey",
    MaxAmount: "最大下单金额:",
    Unlimited: "无限制",
    Edit: "编辑",
    Delete: "删除",
    DeleteConfirmTitle: "确定删除该子账户吗？此操作不可恢复",
    DeleteConfirmOk: "删除",
    DeleteConfirmCancel: "取消",
    AddTitle: "添加子账户 API",
    EditTitle: "编辑子账户 API",
    Form: {
      Exchange: "交易所",
      Name: "名称",
      ApiKey: "API Key",
      SecretKey: "Secret Key",
      Passphrase: "Passphrase",
      MaxAmount: "最大下单金额 (USDT)",
      MaxAmountPlaceholder: "填入 0 表示最大下单金额无限制",
      AuthList: "交易授权",
      SpotTrade: "现货交易",
      FutureTrade: "合约交易",
      SecretKeyEditLabel: "Secret Key（为保证API安全，Secret Key 不会展示）",
      PassphraseEditLabel: "Passphrase（为保证API安全，Passphrase 不会展示）",
      SecretKeyEditPlaceholder: "留空表示不修改原有Secret Key",
      PassphraseEditPlaceholder: "留空表示不修改原有Passphrase",
      NamePlaceholder: "请输入名称",
      ApiKeyPlaceholder: "请输入API Key",
      SecretKeyPlaceholder: "请输入Secret Key",
      PassphrasePlaceholder: "请输入Passphrase",
      Save: "保存",
      Cancel: "取消",
    },
    Futuresmkt: {
      AccountNo: "资金账号",
      AccountNoPlaceholder: "请输入交易账号，如 30000018",
      PwdMd5: "登录密码 MD5",
      PwdMd5Placeholder: "请输入 32 位小写 MD5，非明文密码",
      PwdMd5EditLabel: "登录密码 MD5（已保存值不会展示）",
      PwdMd5EditPlaceholder: "留空表示不修改；若修改须为 32 位小写 MD5",
      OrgCode: "机构代码",
      OrgCodePlaceholder: "选填，如 trade；留空使用服务端默认",
      OrgCodeEditLabel: "机构代码（已保存值不会展示）",
      OrgCodeEditPlaceholder: "留空表示不修改",
    },
    Rules: {
      ExchangeRequired: "请选择交易所",
      NameRequired: "请输入名称",
      ApiKeyRequired: "请输入API Key",
      SecretKeyRequired: "请输入Secret Key",
      PassphraseRequired: "请输入Passphrase",
      MaxAmountRequired: "请输入最大下单金额",
      FuturesmktAccountNoRequired: "请输入资金账号",
      FuturesmktPwdMd5Required: "请输入登录密码 MD5",
      FuturesmktPwdMd5Invalid: "须为 32 位小写十六进制 MD5",
    },
    Messages: {
      CopySuccess: "APIKey已复制到剪贴板",
      CopyFailed: "复制失败，请手动复制",
      LoadFailed: "加载子账户失败",
      SaveSuccess: "已保存子账户 API 信息",
      SaveFailed: "保存失败",
      AddSuccess: "已添加子账户 API 信息",
      AddFailed: "保存失败",
      DeleteSuccess: "已删除子账户",
      DeleteFailed: "删除失败",
    },
  },
  components_tradeheader: {
    menu: {
      trade: "交易",
      aiTrade: "AI 交易",
      news: "资讯",
    },
    auth: {
      login: "登录",
      signup: "注册",
    },
    subAccount: {
      trigger: "子账户选择",
    },
    user: {
      notLoggedIn: "未登录",
    },
    userMenu: {
      manageSubAccount: "管理子账户",
      stats: "数据统计",
      riskPanel: "风控面板",
      invite: "邀请返利",
      settings: "账号设置",
      logout: "退出登录",
    },
    messages: {
      title: "消息",
      markAllRead: "全部已读",
      empty: "暂无消息",
      tradeType: "交易消息",
      newsType: "实时资讯",
    },
    tradeDropdown: {
      favTitle: "自选",
      favDescription: "管理您的自选交易对",
      spotDescription: "轻松买卖加密数字货币",
      contractDescription: "交易永续和交割合约，灵活使用杠杆",
      futuresmktTitle: "传统期货",
      futuresmktDescription: "交易全球大宗商品与指数期货",
    },
    futuresmktPanel: {
      futuresTag: "期货",
      categoryAll: "全部",
      categorySoyChain: "大豆链",
      categoryGrains: "谷物",
      categoryUsIndex: "美股指数",
      categoryPreciousMetals: "贵金属",
      categoryCommodityFx: "商品货币",
    },
    symbolSelect: {
      marketCrypto: "加密货币",
      marketFuturesmkt: "传统期货",
    },
    language: {
      zh_CN: "简体中文",
      zh_TW: "繁體中文",
      en: "English",
    },
    modal: {
      loginTitle: "登录",
      signupTitle: "注册",
    },
  },
  components_apiselect: {
    searchPlaceholder: "搜索子账户",
    syncTooltip: "主账户交易时，激活的子账户将按此比例同步交易",
    activateAll: "激活全部",
    disableAll: "禁用全部",
    activate: "激活",
    disable: "禁用",
    unnamedAccount: "未命名账户",
    mainTag: "主账户",
    copyApiKey: "复制API Key",
    syncScale: "同步比例",
    emptyNoMatch: "未找到匹配的子账户",
    emptyNoApis: "暂无子账户",
    activatedAllSuccess: "已激活 {name} 的所有账户",
    disabledAllSuccess: "已禁用 {name} 的所有账户",
    apiKeyEmpty: "API Key 为空",
    copySuccess: "API Key 已复制到剪贴板",
    copyFailed: "复制失败，请手动复制",
    noResult: "没有找到匹配的交易对",
    loadFailed: "加载失败",
    retry: "重试",
    searchSymbolPlaceholder: "搜索交易对",
  },
  ApiManageModal: {
    ApiManage: {
      Title: "API管理",
      AddApi: "添加API",
      BatchEdit: "批量编辑",
      BatchDelete: "批量删除",
      Exchange: "交易所",
      CustomName: "自定义名称",
      ApiKey: "API Key",
      SecretKey: "Secret Key",
      Passphrase: "Passphrase",
      Permissions: "API权限",
      MaxAmount: "最大下单金额",
      Status: "状态",
      Action: "操作",
      Active: "激活",
      Inactive: "停用",
      Add: "添加",
      Save: "保存",
      Cancel: "取消",
      DeleteConfirm: "确定要删除这个API吗？",
      BatchEditTip: "将对选中的 {count} 个API进行批量编辑",
      PermissionTypes: {
        Spot: "现货",
        Futures: "合约",
        Margin: "杠杆",
        Options: "期权",
      },
    },
  },
  txui: {
    fng: {
      title: "贪婪指数",
      detail: "详情",
      Day: "天",
      Days: "天",
      history: {
        yesterday: "昨日",
        lastWeek: "上周",
        lastMonth: "上个月",
      },
      labels: {
        extremeGreed: "极度贪婪",
        greed: "贪婪",
        neutral: "中性",
        fear: "恐惧",
        extremeFear: "极度恐惧",
      },
      timeFilters: {
        all: "全部",
        week: "1周",
        month: "1月",
        year: "1年",
      },
    },
    user_account: {
      avatar: "用户头像",
      account_info: "账号信息",
      nickname: "昵称",
      edit_nickname: "编辑昵称",
      email: "邮箱",
      edit_email: "修改邮箱",
      security_method: "验证方式",
      phone: "手机号",
      edit_phone: "修改手机号",
      login_password: "登录密码",
      edit_password: "修改登录密码",
      modal_nickname_title: "修改昵称",
      new_nickname: "新昵称",
      placeholder_nickname: "请输入新昵称",
      modal_email_title: "修改邮箱",
      new_email: "新邮箱",
      placeholder_email: "请输入新邮箱",
      verification_code: "验证码",
      placeholder_code: "请输入验证码",
      send_code: "发送验证码",
      modal_phone_title: "修改手机号",
      new_phone: "新手机号",
      placeholder_phone: "请输入新手机号",
      modal_password_title: "修改密码",
      old_password: "旧密码",
      placeholder_old_password: "请输入旧密码",
      new_password: "新密码",
      placeholder_new_password: "请输入新密码",
      confirm_password: "确认新密码",
      placeholder_confirm_password: "请再次输入新密码",
      cancel: "取消",
      confirm: "确定",
      nickname_success: "昵称修改成功",
      nickname_fail: "昵称修改失败",
      email_success: "邮箱修改成功",
      email_fail: "邮箱修改失败",
      phone_success: "手机号修改成功",
      phone_fail: "手机号修改失败",
      password_success: "密码修改成功",
      password_fail: "密码修改失败",
      update_fail: "修改失败，请重试",
      user_info_fail: "更新用户信息失败",
      wait_retry: "请等待 {seconds} 秒后重试",
      code_sent_email: "验证码已发送到邮箱",
      code_fail: "验证码发送失败",
      code_sent_phone: "验证码已发送到手机",
      copy_success: "复制成功",
      copy_fail: "复制失败",
      valid_email: "请输入有效的邮箱地址",
      nickname_length: "昵称长度在 2 到 20 个字符",
      valid_phone: "请输入有效的11位手机号",
      password_length: "密码长度不能少于 6 个字符",
      password_mismatch: "两次输入的密码不一致",
      input_new_nickname: "请输入新昵称",
      input_new_email: "请输入新邮箱",
      input_new_phone: "请输入新手机号",
      input_code: "请输入验证码",
      input_old_password: "请输入旧密码",
      input_new_password: "请输入新密码",
      input_confirm_password: "请再次输入新密码",
    },
    monthSummary: {
      auth: "授权验证",
      inputPassword: "请输入密码以查看月度报告",
      placeholder: "请输入密码",
      verify: "验证",
      query: "查询",
      marketMakerReport: "组合策略月度报告",
      arbOptionReport: "期权策略月度报告",
      arbStatReport: "统计套利月度报告",
      arbStatStrategy: "统计套利策略",
      summary: "摘要：",
      summaryText1: "本报告总结了",
      summaryText2: "在",
      summaryText3: "。期间绝对收益为",
      summaryText4: "%，最大回撤为",
      summaryText5: "%，显示出策略在市场波动中良好的盈利能力和抗风险能力。",
      netValueCurve: "净值曲线",
      exportNetValue: "导出净值",
      dataSource: "数据来源于第三方托管账户",
      drawdownCurve: "回撤曲线",
      performanceMetrics: "{date}业绩指标",
      absoluteReturn: "绝对收益",
      annualizedReturn: "年化收益",
      sharpeRatio: "夏普",
      maxDrawdown: "最大回撤",
      marketEnvironmentAnalysis: "市场环境分析：",
      disclaimer: "免责声明：",
      disclaimerText:
        "此报告不预示或保证任何未来业绩，并不应被视为本公司的任何承诺或邀约。本文件非用于任何宣传推介之用，不构成对任何人的投资建议或邀约。市场投资存在风险，请谨慎对待。",
      dataSourceDisclaimer: "数据来源声明：",
      dataSourceText: "数据来源于第三方托管账户。",
      copyrightDisclaimer: "版权声明：",
      copyrightText:
        "本报告的版权归TradingX所有，未经书面授权，任何机构或个人不得以任何形式复制、传播或用于商业目的。",
      passwordError: "密码错误，请重新输入",
      marketMakerStrategy: "组合策略",
      optionStrategy: "期权策略",
      dateMonth: "在{year}年{month}月份的表现",
      dateRange:
        "在{startYear}年{startMonth}月至{endYear}年{endMonth}月期间的表现",
      dateDisplayMonth: "{year}年{month}月",
      dateDisplayRange: "{startYear}年{startMonth}月 - {endYear}年{endMonth}月",
      netValue: "净值",
      drawdown: "回撤",
    },
  },
  views_riskControl: {
    header: {
      title: "风控面板",
      subtitle: "基于策略实例组合的风险与收益监控，支持时间区间回测视角。",
    },
    tabs: {
      accountRisk: "账号风控",
      strategyList: "策略风控",
      overviewExposure: "策略回看",
    },
    filter: {
      timeRange: "时间段",
      preset1d: "1天",
      preset7d: "7天",
      preset30d: "30天",
      presetMtd: "本月",
      presetYtd: "今年",
      presetLastMonth: "上月",
      presetWeek: "本周以来",
      presetMonth: "本月以来",
      presetYear: "本年以来",
      presetCustom: "自定义",
      customRange: "自定义区间",
      startDate: "开始日期",
      endDate: "结束日期",
      apiAccounts: "API 账户（多选）",
      selectApiPlaceholder: "请选择 API 账户",
      apiNotFound: "未找到匹配的 API 账户",
      strategyInstances: "策略实例（多选即投资组合）",
      selectStrategyPlaceholder: "请选择策略实例",
      strategyNotFound: "未找到匹配的策略",
    },
    overview: {
      title: "概览",
      periodRange: "{start} ~ {end}",
      startNetAsset: "期初净资产",
      endNetAsset: "期末净资产",
      intervalPnl: "区间收益",
      returnRate: "区间收益率",
      annualizedReturn: "区间年化收益率",
      maxDrawdown: "区间最大回撤",
      navVolatility: "区间净值波动率（年化）",
      sharpeRatio: "区间夏普比率",
      chartEquityDrawdown: "累计净值 & 回撤",
      chartNetAssetPnl: "净资产 & 区间收益",
    },
    exposure: {
      title: "敞口比例 & 杠杆率",
      netExposureRate: "区间平均净敞口率",
      absExposureRate: "区间平均绝对敞口率",
      avgExposureRate: "区间平均敞口率",
      avgLeverage: "区间平均杠杆率",
      maxLeverage: "区间峰值杠杆率",
      chartExposureLeverage: "净敞口率 / 绝对敞口率 / 杠杆率",
      chartAvgExposureTrend: "平均敞口率走势",
      chartContribution: "多策略收益贡献（堆叠）",
      chartDistribution: "敞口分布（净敞口率）",
    },
    accountOverview: {
      title: "账号概览",
      totalAsset: "总资产",
      todayPnl: "今日盈亏",
      exposureRate: "当前敞口",
      leverageRate: "杠杆率",
      navChartTitle: "净值走势",
      navSeries: "账户净值",
      navRange24h: "24小时",
      navRange7d: "7日",
      navRange1w: "1周",
      navRange1m: "1个月",
      navRange1y: "1年",
    },
    lendingInfo: {
      title: "借币信息",
      columns: {
        apiAccount: "API 账户",
        side: "方向",
        asset: "币种",
        amount: "数量",
        annualRate: "年化利率",
        currentInterest: "当前利息",
        notionalValue: "折合价值",
      },
      side: {
        borrow: "借入",
        lend: "借出",
      },
    },
    fundFlow: {
      title: "资金明细",
      filterAll: "全部 API",
      filterApiPlaceholder: "筛选 API",
      columns: {
        time: "时间",
        apiAccount: "API 账户",
        type: "类型",
        amount: "变动金额",
        balanceAfter: "变动后余额",
        remark: "备注",
      },
      type: {
        deposit: "充值",
        withdraw: "提现",
        transferIn: "划入",
        transferOut: "划出",
        fee: "手续费",
      },
    },
    strategyList: {
      title: "实时策略列表",
      refresh: "刷新",
      riskFilterAll: "全部状态",
      riskFilterNormal: "正常",
      riskFilterWarning: "预警",
      riskFilterDanger: "危险",
      riskFilterDisabled: "关闭",
      stopAll: "停止所有策略",
      confirmStop: "确认停止",
      cancel: "取消",
      confirmStopAllTitle: "确认停止所有策略？",
      confirmStopAllDesc: "此操作将停止所有运行中的策略实例，请谨慎确认。",
      save: "保存",
      edit: "编辑",
      riskInfo: "风控信息",
      confirmStopStrategyTitle: "确认停止该策略？",
      confirmStopStrategyDesc: "停止后该策略实例将不再执行新的交易指令。",
      stopped: "已停止",
      stopStrategy: "停止策略",
      columns: {
        strategy: "策略",
        riskStatus: "风控状态",
        totalAsset: "策略总资产",
        todayPnl: "已实现盈亏",
        currentPnl: "未实现盈亏",
        returnRate: "收益率",
        intradayDrawdown: "当日回撤",
        maxDrawdown: "最大回撤",
        exposureRate: "当前敞口",
        leverageRate: "杠杆率",
        sharpeRatio: "夏普比率",
        riskEnabled: "启用风控",
        warnSettings: "预警值设置",
        dangerSettings: "危险值设置",
        dangerActions: "触发危险值后",
        runningTime: "策略运行时间",
        action: "操作",
      },
      runningTimeFormat: {
        daysHoursMinutes: "{days}天 {hours}小时 {minutes}分",
        hoursMinutesSeconds: "{hours}小时 {minutes}分 {seconds}秒",
        stopped: "（已停止）",
      },
      threshold: {
        maxDrawdown: "最大回撤",
        leverage: "杠杆率",
        netExposure: "净敞口",
        absExposure: "绝对敞口",
      },
    },
    dangerAction: {
      log: "仅记录",
      notify: "告警提示",
      reduceOnly: "仅减仓",
      blockNewPosition: "禁止开新仓",
      stopStrategy: "停止策略",
    },
    riskInfoModal: {
      title: "风控状态信息",
      statusTitle: "风控状态",
      currentRiskLevel: "当前风险等级",
      currentTriggers: "当前触发项",
      lastTriggerTime: "最后触发时间",
      alertList: "告警列表",
      filterAll: "全部",
      filterWarning: "预警",
      filterDanger: "危险",
      noAlerts: "当前无告警",
      triggerRecords: "触发记录（最近 20 条）",
      noTriggerRecords: "当前无触发记录",
      alertMeta: "当前 {current} / 阈值 {threshold}",
    },
    riskLevel: {
      disabled: "关闭",
      danger: "危险",
      warning: "预警",
      normal: "正常",
    },
    riskStatus: {
      riskDisabled: "风控已关闭",
      noTrigger: "无触发",
    },
    metrics: {
      maxDrawdown: "最大回撤",
      leverage: "杠杆率",
      netExposureRate: "净敞口率",
      absExposureRate: "绝对敞口率",
    },
    event: {
      drawdownDesc: "当前 {value}%，触及阈值",
      leverageDesc: "当前 {value}x，触及阈值",
    },
    chart: {
      cumulativeNav: "累计净值",
      drawdown: "回撤",
      drawdownPercent: "回撤(%)",
      netAsset: "净资产",
      intervalPnl: "区间收益",
      intervalPnlProfit: "区间收益(盈)",
      intervalPnlLoss: "区间收益(亏)",
      netExposureRate: "净敞口率",
      absExposureRate: "绝对敞口率",
      leverage: "杠杆率",
      exposureRatePercent: "敞口率(%)",
      avgExposureRate: "平均敞口率",
      sampleCount: "样本数",
    },
  },
};
